<template>
  <div style="width: 100%">
    <v-snackbar v-model="showSnackbar" :color="snackbar.color" transition="slide-y-reverse-transition">
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="showSnackbar = false"
        >
          {{getTranslated('_close')}}
        </v-btn>
      </template>
    </v-snackbar>

    <ConfirmationDialog
      :showDialog="showConfirmationDialog"
      :text="getTranslated('_deleteComponent')"
      @accept="deleteItem()"
      @cancel="cancelDeleteDialog"
    ></ConfirmationDialog>

    <ConfirmationDialog
      :showDialog="showConfirmationDialog2"
      :text="getTranslated('_changesWithoutSaving')"
      @accept="exitPage()"
      @cancel="cancelDeleteDialog2"
    ></ConfirmationDialog>

    <v-dialog v-model="showDeleteCanvasDialog" max-width="340px" persistent @keydown.esc="showDeleteCanvasDialog = false" @keydown.enter="showDeleteCanvasDialog = false; clearCanvasDialog()">
      <v-card align="center">
        <v-card-title class="text-h5 justify-center">{{getTranslated('_areYouSure')}}</v-card-title>
        <v-card-text>{{getTranslated('_deleteMessageAlert')}}</v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" text @click="showDeleteCanvasDialog = !showDeleteCanvasDialog; clearCanvasDialog()">{{getTranslated('_yes')}}</v-btn>
          <v-btn color="primary" text @click="showDeleteCanvasDialog = !showDeleteCanvasDialog">{{getTranslated('_no')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showSetLabelDescription" max-width="540px" persistent @keydown.esc="showSetLabelDescription = false" @keydown.enter="showSetLabelDescription = false; saveExistentLabel()">
      <v-card>
        <v-card-title class="text-h5 justify-center">{{getTranslated('_addNewDescription')}}</v-card-title>
        <v-textarea class="mx-6" outlined auto-grow maxlength="255" counter="255" :label="getTranslated('_description')" type="text" v-model="labelDescription"></v-textarea>
        <v-card class="mx-6 my-3">
            <v-row v-for="(item, index) in purposes" :key="index" align="center">
              <div style="width: 220px"><v-select class="mx-6" :items="purposesList" v-model="item.Type" item-text="purposeTypeName" item-value="id" :label="getTranslated('_name')" :no-data-text="getTranslated('_selectNoData')"></v-select></div>
              <div style="width: 220px"><v-text-field class="mx-6" :label="getTranslated('_value')" v-model="item.Value"></v-text-field></div>
              <v-btn class="mr-6" icon color="primary" @click="deleteNameValue(item)"><v-icon>delete</v-icon></v-btn>
            </v-row>
            <v-row align="center">
              <div style="width: 220px"><v-select class="mx-6" :items="purposesList" v-model="newName" item-text="purposeTypeName" item-value="id" :label="getTranslated('_name')" :no-data-text="getTranslated('_selectNoData')"></v-select></div>
              <div style="width: 220px"><v-text-field class="mx-6" :label="getTranslated('_value')" v-model="newValue"></v-text-field></div>
              <v-btn class="mr-6" icon color="primary" @click="addNewNameValue()" :disabled="!newName"><v-icon>add_circle_outline</v-icon></v-btn>
            </v-row>
          </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showSetLabelDescription = !showSetLabelDescription; saveExistentLabel()" :loading="saveLoading">{{getTranslated('_accept')}}</v-btn>
          <v-btn color="primary" text @click="showSetLabelDescription = !showSetLabelDescription">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showChangeCanvasSizeDialog" max-width="540px" persistent @keydown.esc="showChangeCanvasSizeDialog = false">
      <v-card>
        <v-card-title class="text-h5 justify-center">{{getTranslated('_newLabelSize')}}</v-card-title>
        <v-text-field class="mx-6" min="0" :label="getTranslated('_width')" hint="mm" type="number" v-model="canvasWidthDialog" max="157"></v-text-field>
        <v-text-field class="mx-6" min="0" :label="getTranslated('_height')" hint="mm" type="number" v-model="canvasHeightDialog"></v-text-field>
        <v-card-text>{{getTranslated('_labelSizeAdvice')}}</v-card-text>
        <v-card-text>{{getTranslated('_labelSizeAdvice2')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showChangeCanvasSizeDialog = !showChangeCanvasSizeDialog; changeCanvasSizeDialog()">{{getTranslated('_accept')}}</v-btn>
          <v-btn color="primary" text @click="showChangeCanvasSizeDialog = !showChangeCanvasSizeDialog">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showSaveDialog" max-width="540px" persistent @keydown.esc="showSaveDialog = false">
      <v-card>
        <v-card-title class="text-h5 justify-center">{{getTranslated('_saveOptions')}}</v-card-title>
        <v-form v-model="valid" ref="form">
          <v-text-field class="mx-6" :rules="requiredRule" :label="getTranslated('_labelName')" v-model="saveNameDialog"></v-text-field>
          <v-text-field class="mx-6" :label="getTranslated('_description')" v-model="labelDescription"></v-text-field>
          <v-card class="mx-6 mb-3">
            <v-row v-for="(item, index) in purposes" :key="index" align="center">
              <div style="width: 220px"><v-select class="mx-6" :items="purposesList" v-model="item.Type" item-text="purposeTypeName" item-value="id" :label="getTranslated('_name')" :no-data-text="getTranslated('_selectNoData')"></v-select></div>
              <div style="width: 220px"><v-text-field class="mx-6" :label="getTranslated('_value')" v-model="item.Value"></v-text-field></div>
              <v-btn class="mr-6" icon color="primary" @click="deleteNameValue(item)"><v-icon>delete</v-icon></v-btn>
            </v-row>
            <v-row align="center">
              <div style="width: 220px"><v-select class="mx-6" :items="purposesList" v-model="newName" item-text="purposeTypeName" item-value="id" :label="getTranslated('_name')" :no-data-text="getTranslated('_selectNoData')"></v-select></div>
              <div style="width: 220px"><v-text-field class="mx-6" :label="getTranslated('_value')" v-model="newValue"></v-text-field></div>
              <v-btn class="mr-6" icon color="primary" @click="addNewNameValue()" :disabled="!newName"><v-icon>add_circle_outline</v-icon></v-btn>
            </v-row>
          </v-card>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip top :disabled="valid" transition="slide-y-reverse-transition">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn color="primary" text @click="showSaveDialog = !showSaveDialog; exportDialog()" :disabled="!valid" :loading="saveLoading">{{getTranslated('_accept')}}</v-btn>
              </div>
            </template>
            <span>{{getTranslated('_saveRequiredValuesAlert')}}</span>
          </v-tooltip>
          <v-btn color="primary" text @click="showSaveDialog = !showSaveDialog">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMultiSelectDialog" max-width="540px" persistent @keydown.esc="showMultiSelectDialog = false">
      <v-card>
        <v-card-title>{{getTranslated('_moreThanOneMessage')}}</v-card-title>
        <v-select class="ma-6" :items="multiSelectList" item-text="name" v-model="multiSelected" return-object :no-data-text="getTranslated('_selectNoData')"></v-select>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text :disabled="Object.keys(multiSelected).length === 0" @click="showMultiSelectDialog = !showMultiSelectDialog; moreThanOneAlert()">{{getTranslated('_accept')}}</v-btn>
          <v-btn color="primary" text @click="showMultiSelectDialog = !showMultiSelectDialog">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showChangeNameDialog" max-width="540px" persistent @keydown.esc="showChangeNameDialog = false">
      <v-card>
        <v-card-title class="text-h5 justify-center">{{getTranslated('_writeNewName')}}</v-card-title>
        <v-text-field class="mx-6 pa-0" v-model="changeName"></v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text :disabled="changeName === ''" @click="changeNameFunc(); showChangeNameDialog = !showChangeNameDialog">{{getTranslated('_accept')}}</v-btn>
          <v-btn color="primary" text @click="showChangeNameDialog = !showChangeNameDialog">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showImportImage" max-width="540px" persistent @keydown.esc="showImportImage = false">
      <v-card>
        <v-card-title class="text-h5 justify-center">{{getTranslated('_importImage')}}</v-card-title>
        <v-text-field class="mx-6 pa-0" v-model="imageName" :label="getTranslated('_imageName')"></v-text-field>
        <v-file-input class="mx-6 pa-0" :label="getTranslated('_selectFile')" accept="image/*" value="importedImagesDialog" v-model="importedImageDialog"></v-file-input>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text :disabled="imageName === '' || importedImageDialog === null" @click="showImportImage = !showImportImage; importImageDialog()">{{getTranslated('_accept')}}</v-btn>
          <v-btn color="primary" text @click="showImportImage = !showImportImage">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showImportJson" max-width="540px" persistent @keydown.esc="showImportJson = false">
      <v-card>
        <v-card-title class="text-h5 justify-center">{{getTranslated('_importFromJsonFile')}}</v-card-title>
        <v-file-input class="mx-6 pa-0" :label="getTranslated('_selectFile')" accept="application/json" v-model="importedJsonDialog"></v-file-input>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text :disabled="importedJsonDialog === undefined || importedJsonDialog === null" @click="showImportJson = !showImportJson; importJsonDialog()">{{getTranslated('_accept')}}</v-btn>
          <v-btn color="primary" text @click="showImportJson = !showImportJson">{{getTranslated('_cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showZplLabelDialog" max-width="540px" persistent @keydown.esc="showZplLabelDialog = false">
      <v-card>
        <v-card-title class="text-h5 justify-center">{{getTranslated('_zplLabelCode')}}</v-card-title>
        <v-textarea v-model="zplLabelCode" class="mx-6" outlined id="zplTextArea"></v-textarea>
        <v-card-actions>
          <v-tooltip v-model="showTooltipZplLabelDialog" top>
            <template v-slot:activator="data" & v-on="data.on">
              <v-btn color="primary" text onclick="document.getElementById('zplTextArea').select();document.execCommand('copy')" @click="showZplLabelDialogTooltip()">{{getTranslated('_copyToClipboard')}}</v-btn>
            </template>
            <span>{{getTranslated('_copied')}}</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showZplLabelDialog = !showZplLabelDialog">{{getTranslated('_close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div id="Code_Charger">
      <img id="barcode" class="barcode" />
    </div>

    <v-skeleton-loader
      :loading="loading"
      type="heading"
      class="ml-12"
      transition="fade-transition"
    >
      <span class="text-h5" style="display: flex">{{getTranslated('_labelDesigner')}}</span>
    </v-skeleton-loader>

    <v-container fluid>
      <v-row>
        <v-col cols="9">
          <v-row>
            <v-col style="display: flex; flex-wrap: wrap" class="pl-10">
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2 my-1"
                transition="fade-transition"
              >
                <v-btn color="primary" outlined @click="showDeleteCanvasDialog = !showDeleteCanvasDialog; diselectItem()" small>{{getTranslated('_clearLabel')}}</v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2 my-1"
                transition="fade-transition"
                v-if="$route.params.id === undefined && etiquetaID === ''"
              >
                <v-btn color="primary" outlined @click="showSaveDialog = !showSaveDialog; saveNameDialog = ''; labelDescription = ''; diselectItem()" small>{{getTranslated('_save')}}</v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2 my-1"
                transition="fade-transition"
                v-else
              >
                <v-btn color="primary" outlined @click="showSetLabelDescription = !showSetLabelDescription" small>{{getTranslated('_save')}}</v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2 my-1"
                transition="fade-transition"
              >
                <v-btn color="primary" outlined @click="showChangeCanvasSizeDialog = !showChangeCanvasSizeDialog; diselectItem()" small>{{getTranslated('_canvas')}}</v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2 my-1"
                transition="fade-transition"
              >
                <v-btn color="primary" outlined @click="changeModeDialog()" small>{{buttonModeText}}</v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2 my-1"
                transition="fade-transition"
              >
                <v-btn color="primary" outlined @click="showImportImage = !showImportImage; imageName = ''; importedImageDialog = null; diselectItem()" small>{{getTranslated('_importImage')}}</v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2 my-1"
                transition="fade-transition"
              >
                <v-btn color="primary" outlined @click="exportLabel(); diselectItem()" small>{{getTranslated('_exportAsZPL')}}</v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2 my-1"
                transition="fade-transition"
              >
                <v-btn color="primary" outlined @click="exportToPDF(); diselectItem()" small>{{getTranslated('_exportAsPDF')}}</v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2 my-1"
                transition="fade-transition"
              >
                <v-btn color="primary" outlined @click="exportToJson(); diselectItem()" small>{{getTranslated('_exportAsJSON')}}</v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2 my-1"
                transition="fade-transition"
              >
                <v-btn color="primary" outlined @click="importAsJson(); diselectItem()" small>{{getTranslated('_import')}}</v-btn>
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row>
            <v-col style="display: flex; flex-wrap: wrap" class="pl-10">
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2"
                transition="fade-transition"
              >
                <v-btn color="primary" @click="dibujarLinea(); ver = 'Vertical'; show = true" icon x-large><v-icon color="#2c3e50">fas fa-grip-lines-vertical</v-icon></v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2"
                transition="fade-transition"
              >
                <v-btn color="primary" @click="dibujarSquare(); show = true" small icon x-large><v-icon color="#2c3e50">fas fa-vector-square</v-icon></v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2"
                transition="fade-transition"
              >
                <v-btn color="primary" @click="dibujarText(false); textType = 'Texto';magnetic = 'Disabled'; show = true" icon x-large><v-icon color="#2c3e50">fa-font</v-icon></v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2"
                transition="fade-transition"
              >
                <v-btn color="primary" @click="dibujarText(true); textType = 'Etiqueta';magnetic = 'Disabled'; show = true" icon x-large><v-icon color="#2c3e50">fas fa-code</v-icon></v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2"
                transition="fade-transition"
              >
                <v-btn color="primary" @click="dibujarCode(); typeOfCode = 'CODE128'; show = true" icon x-large><v-icon color="#2c3e50">fa-barcode</v-icon></v-btn>
              </v-skeleton-loader>
              <v-skeleton-loader
                :loading="loading"
                type="button"
                class="mx-2"
                transition="fade-transition"
              >
                <v-btn color="primary" @click="dibujarImage(); show = true; image = 'Predefined'" small icon x-large><v-icon color="#2c3e50">far fa-image</v-icon></v-btn>
              </v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card id="vcard" :tile="true" class="ml-12" outlined :width="canvasWidth" :height="canvasHeight" style="background-color: transparent">
                <div id="CANVAS_container">
                  <canvas id="CANVAS" width="600" height="700"></canvas>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
        <canvas id="barcodeCanvas" style="display: none"></canvas>
        <v-col cols="3">
          <v-skeleton-loader
            :loading="loading"
            type="article"
            class="elevation-1"
            transition="fade-transition"
          >
            <v-card outlined>
              <v-card-title>{{getTranslated('_list')}}</v-card-title>
              <v-select :items="lista" item-text="name" item-value="id" v-model="selectedItem" return-object :label="getTranslated('_selectedComponent')" class="mx-6 pa-0" @change="selectItem(selectedItem.id)" :no-data-text="getTranslated('_selectNoData')"></v-select>
              <v-form>
                <v-container>
                  <div v-if="selectedItem.type === 'square'">
                    <v-text-field min="0" :max="selectedItem.xMax" class="mx-6 pa-0" v-model="selectedItem.x" label="X" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field min="0" :max="selectedItem.yMax" class="mx-6 pa-0" v-model="selectedItem.y" label="Y" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field class="mx-6 pa-0" v-model="selectedItem.width" :label="getTranslated('_width')" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field class="mx-6 pa-0" v-model="selectedItem.height" :label="getTranslated('_height')" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field min="2" class="mx-6 pa-0" v-model="selectedItem.thickness" :label="getTranslated('_size')" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                  </div>
                  <div v-if="selectedItem.type === 'line'">
                    <v-text-field min="0" :max="selectedItem.xMax" class="mx-6 pa-0" v-model="selectedItem.x" label="X" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field min="0" :max="selectedItem.yMax" class="mx-6 pa-0" v-model="selectedItem.y" label="Y" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field min="0" class="mx-6 pa-0" v-model="selectedItem.length" :label="getTranslated('_length')" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-select class="mx-6 pa-0" :label="getTranslated('_direction')" :items="directionList" v-model="ver" @change="changeDirection()" :no-data-text="getTranslated('_selectNoData')"></v-select>
                    <v-text-field min="2" class="mx-6 pa-0" v-model="selectedItem.thickness" :label="getTranslated('_size')" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                  </div>
                  <div v-if="selectedItem.type === 'text'">
                    <v-text-field min="0" class="mx-6 pa-0" v-model="selectedItem.x" label="X" type="number" dense @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field min="0" class="mx-6 pa-0" v-model="selectedItem.y" label="Y" type="number" dense @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field min="0" class="mx-6 pa-0" v-model="selectedItem.fontSize" :label="getTranslated('_size')" type="number" dense @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-select class="mx-6 pa-0" v-model="magnetic" :items="magneticList" dense @change="changeMagneticType()" :label="getTranslated('_magnetic')" :no-data-text="getTranslated('_selectNoData')"></v-select>
                    <v-select class="mx-6 pa-0" v-model="selectedItem.orientation" :label="getTranslated('_orientation')" :items="orientationList" dense @input="actualizar(selectedItem.id)">
                      <template slot="item" slot-scope="data">
                        <v-icon v-text="getOrientationIcon(data.item)"></v-icon>
                        <span class="ml-3">{{data.item}}</span>
                      </template>
                    </v-select>
                    <!-- <v-text-field class="mx-6 pa-0" v-model="selectedItem.fontName" :label="getTranslated('_font')" dense @input="actualizar(selectedItem.id)"></v-text-field> -->
                    <v-select class="mx-6 pa-0" :items="textTypeList" :label="getTranslated('_type')" v-model="textType" dense @change="changeTextType()" :no-data-text="getTranslated('_selectNoData')"></v-select>
                    <v-text-field v-if="!selectedItem.placeholder" class="mx-6 pa-0" v-model="selectedItem.fieldName" :label="getTranslated('_text')" dense @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field v-if="selectedItem.placeholder" class="mx-6 pa-0" v-model="selectedItem.fieldName" :label="getTranslated('_identifier')" dense @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field v-if="selectedItem.placeholder" class="mx-6 pa-0" v-model="selectedItem.value" :label="getTranslated('_example')" dense @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-checkbox class="mx-6 pa-0 mt-0" v-model="selectedItem.inverse" :label="getTranslated('_inverse')" dense @change="actualizar(selectedItem.id)" color="primary"></v-checkbox>
                  </div>
                  <div v-if="selectedItem.type === 'code'">
                    <v-text-field class="mx-6 pa-0" :max="selectedItem.xMax" v-model="selectedItem.x" label="X" type="number" dense @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field class="mx-6 pa-0" :max="selectedItem.yMax" v-model="selectedItem.y" label="Y" type="number" dense @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field min="1" v-if="typeOfCode !== 'datamatrix' && typeOfCode !== 'maxicode' && typeOfCode !== 'hibcpdf417'" class="mx-6 pa-0" v-model="selectedItem.w" :label="getTranslated('_width')" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field min="1" v-if="typeOfCode !== 'datamatrix' && typeOfCode !== 'maxicode'" class="mx-6 pa-0" v-model="selectedItem.h" :label="getTranslated('_height')" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field v-if="typeOfCode === 'datamatrix'" min="5" class="mx-6 pa-0" v-model="selectedItem.s" :label="getTranslated('_size')" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-select class="mx-6 pa-0" :label="getTranslated('_orientation')" :items="codeOrientationList" v-model="selectedItem.orientation" dense @input="actualizar(selectedItem.id)">
                      <template slot="item" slot-scope="data">
                        <v-icon v-text="getBarCodeOrientationIcon(data.item)"></v-icon>
                        <span class="ml-3">{{data.item}}</span>
                      </template>
                    </v-select>
                    <v-select class="mx-6 pa-0" :label="getTranslated('_type')" :items="codeList" v-model="typeOfCode" item-text="name" dense @input="actualizar(selectedItem.id)" :no-data-text="getTranslated('_selectNoData')"></v-select>
                    <v-text-field class="mx-6 pa-0" v-model="selectedItem.code" :label="getTranslated('_identifier')" dense @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field class="mx-6 pa-0" v-model="selectedItem.ejemplo" :label="getTranslated('_example')" dense @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-checkbox class="mx-6 pa-0 mt-0" v-if="typeOfCode !== 'datamatrix'" v-model="selectedItem.barcodeText" :label="getTranslated('_showText')" dense @change="actualizar(selectedItem.id)" color="primary"></v-checkbox>
                  </div>
                  <div v-if="selectedItem.type === 'image'">
                    <v-text-field min="0" class="mx-6 pa-0" v-model="selectedItem.x" label="X" type="number" dense @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field min="0" class="mx-6 pa-0" v-model="selectedItem.y" label="Y" type="number" dense @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field min="0" class="mx-6 pa-0" v-model="selectedItem.w" :label="getTranslated('_width')" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-text-field min="0" class="mx-6 pa-0" v-model="selectedItem.h" :label="getTranslated('_height')" type="number" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-select class="mx-6 pa-0" :label="getTranslated('_image')" :items="imagesFrom" v-model="image" @change="changeImageFrom()" :no-data-text="getTranslated('_selectNoData')" v-show="!selectedItem.isVariable"></v-select>
                    <v-select class="mx-6 pa-0" v-if="selectedItem.predefined" :label="getTranslated('_selected')" :items="preselectedImages" v-model="selectedImage" item-text="labelImageName" return-object @input="actualizar(selectedItem.id)" :no-data-text="getTranslated('_selectNoData')" v-show="!selectedItem.isVariable"></v-select>
                    <v-select class="mx-6 pa-0" v-else :label="getTranslated('_selected')" :items="importedImages" v-model="selectedImage" item-text="labelImageName" return-object @input="actualizar(selectedItem.id)" :no-data-text="getTranslated('_selectNoData')" v-show="!selectedItem.isVariable"></v-select>
                    <v-text-field min="0" class="mx-6 pa-0" v-model="isVariableName" :label="getTranslated('_variableName')" v-show="selectedItem.isVariable" @input="actualizar(selectedItem.id)"></v-text-field>
                    <v-checkbox class="mx-6 pa-0 mt-0" color="primary" v-model="selectedItem.isVariable" :label="getTranslated('_isVariable')"></v-checkbox>
                  </div>
                  <v-row align="center" justify="space-between" class="mx-4">
                    <v-checkbox color="primary" v-model="show" v-if="Object.keys(selectedItem).length !== 0" :label="getTranslated('_show')" @change="showChange()"></v-checkbox>
                    <v-btn color="primary" text v-if="Object.keys(selectedItem).length !== 0" @click="showChangeNameDialog = !showChangeNameDialog; changeName = selectedItem.name">{{getTranslated('_changeName')}}</v-btn>
                  </v-row>
                  <v-row class="mx-4 mb-1">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text v-if="Object.keys(selectedItem).length !== 0" @click="showConfirmationDialog = true">{{getTranslated('_delete')}}</v-btn>
                  </v-row>
                </v-container>
              </v-form>
            </v-card>
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
    <div id="ImageAmmo">
      <!-- Acumulador de imagenes importadas, para no tener que importarlas -->
    </div>
  </div>
</template>

<script>
import LabelDesignerService from '../services/LabelDesignerService.js'
import translationsService from '../services/TranslationsService'
import bwipjs from 'bwip-js'
import router from '../router'
require('../plugins/jquery-3.4.1')
require('../plugins/jquery-barcode')
require('../plugins/JsBarcode.all')
const ConfirmationDialog = () => import('../components/ConfirmationDialog.vue')

var vueInstance = {
  beforeRouteLeave (to, from, next) {
    let app = router.app.$data || { isAuthenticated: false }
    if (app.isAuthenticated) {
      if (vueInstance.data2.lastActionSave) {
        next()
      } else {
        vueInstance.data2.next = next
        vueInstance.data2.showConfirmationDialog2 = true
      }
    } else {
      next()
    }
  },
  data () {
    return vueInstance.data2
  },
  components: {
    ConfirmationDialog
  },
  data2: {
    lastActionSave: true,
    next: null,
    showConfirmationDialog: false,
    showConfirmationDialog2: false,
    valid: false,
    requiredRule: [v => !!v || vueInstance.methods.getTranslated('_required')],
    lista: [],
    selectedItem: {},
    directionList: ['Vertical', 'Horizontal'],
    ver: 'Vertical',
    exit: false,
    codeList: [
      { value: 'CODE128', name: 'Code 128' },
      { value: 'CODE128A', name: 'Code 128 A' },
      { value: 'CODE128B', name: 'Code 128 B' },
      { value: 'CODE128C', name: 'Code 128 C' },
      { value: 'ITF', name: 'Interleaved 2 of 5' },
      { value: 'CODE39', name: 'Code 3 of 9' },
      { value: 'datamatrix', name: 'DataMatrix' },
      { value: 'EAN13', name: 'GTIN 13' },
      { value: 'maxicode', name: 'Maxicode' },
      { value: 'hibcpdf417', name: 'PDF417' }
    ],
    purposes: [],
    newName: '',
    newValue: '',
    typeOfCode: 'CODE128',
    orientationList: [0, 90, 180, 270],
    codeOrientationList: [0, 90, 270],
    textTypeList: ['Texto', 'Etiqueta'],
    textType: 'Texto',
    magneticList: ['Enabled', 'Disabled'],
    magnetic: 'Disabled',
    canvasWidth: '600px',
    canvasHeight: '700px',
    show: true,
    showDeleteCanvasDialog: false,
    showChangeCanvasSizeDialog: false,
    showSaveDialog: false,
    showMultiSelectDialog: false,
    showChangeNameDialog: false,
    showImportImage: false,
    showImportEtiqueta: false,
    showZplLabelDialog: false,
    showSetLabelDescription: false,
    canvasWidthDialog: 75,
    canvasHeightDialog: 87.5,
    saveNameDialog: '',
    buttonModeText: 'edition',
    multiSelectList: [],
    multiSelected: {},
    changeName: '',
    preselectedImages: [],
    imagesFrom: ['Predefined', 'Imported'],
    image: 'Predefined',
    importedImages: [],
    imageName: '',
    importedImagesDialog: [],
    importedImageDialog: null,
    showSnackbar: false,
    snackbar: {
      color: '',
      message: ''
    },
    labelDescription: '',
    etiquetaID: '',
    etiquetaVersion: '',
    selectedImage: {},
    itemToDelete: '',
    zplLabelCode: '',
    isVariable: false,
    isVariableName: '',
    showTooltipZplLabelDialog: false,
    purposesList: [],
    translations: [
      { key: '_close', translation: 'Close' },
      { key: '_deleteMessageAlert', translation: 'The label will be deleted!' },
      { key: '_areYouSure', translation: 'Do you want to continue?' },
      { key: '_yes', translation: 'Yes' },
      { key: '_no', translation: 'No' },
      { key: '_labelSizeAdvice', translation: 'The label size will have a ratio of 8ppm (pixels per millimeter).' },
      { key: '_labelSizeAdvice2', translation: 'All object measurements will be specified in pixels, not mm' },
      { key: '_accept', translation: 'Accept' },
      { key: '_cancel', translation: 'Cancel' },
      { key: '_moreThanOneMessage', translation: 'There is more than one item selected, which one do you want to select?' },
      { key: '_writeNewName', translation: 'Type the new component name' },
      { key: '_saveOptions', translation: 'Save options' },
      { key: '_importImage', translation: 'Import image' },
      { key: '_importLabel', translation: 'Import label' },
      { key: '_writeLabelId', translation: 'Enter the ID of the label you want to import' },
      { key: '_labelDesigner', translation: 'Label Designer' },
      { key: '_delete', translation: 'Delete' },
      { key: '_canvas', translation: 'Canvas' },
      { key: '_save', translation: 'Save' },
      { key: '_example', translation: 'Exmaple' },
      { key: '_edition', translation: 'Edition' },
      { key: '_width', translation: 'Width' },
      { key: '_height', translation: 'Height' },
      { key: '_size', translation: 'Size' },
      { key: '_direction', translation: 'Direction' },
      { key: '_magnetic', translation: 'Magnetic' },
      { key: '_orientation', translation: 'Orientation' },
      { key: '_font', translation: 'Font' },
      { key: '_type', translation: 'Type' },
      { key: '_text', translation: 'Text' },
      { key: '_identifier', translation: 'Identifier' },
      { key: '_image', translation: 'Image' },
      { key: '_selected', translation: 'Selected' },
      { key: '_show', translation: 'Show' },
      { key: '_changeName', translation: 'Change name' },
      { key: '_vertical', translation: 'Vertical' },
      { key: '_label', translation: 'Label' },
      { key: '_enabled', translation: 'Enabled' },
      { key: '_disabled', translation: 'Disabled' },
      { key: '_predefined', translation: 'Predefined' },
      { key: '_imported', translation: 'Imported' },
      { key: '_labelName', translation: 'Label name' },
      { key: '_imageName', translation: 'Image name' },
      { key: '_selectFile', translation: 'Select a file' },
      { key: '_labelId', translation: 'Label ID' },
      { key: '_horizontal', translation: 'Horizontal' },
      { key: '_newLabelSize', translation: 'Enter the new label size' },
      { key: '_selectedComponent', translation: 'Selected component' },
      { key: '_length', translation: 'Length' },
      { key: '_notPossibleTurnBackEvents', translation: 'Is not possible to turn back the events' },
      { key: '_labelImported', translation: 'Label imported' },
      { key: '_labelImportedError', translation: 'Error importing label' },
      { key: '_imageSaved', translation: 'Image saved' },
      { key: '_imageSavedError', translation: 'Error saving image' },
      { key: '_imageLimitSizeError', translation: 'The image you are trying to load weighs more than 20 KB' },
      { key: '_imageLoadFormatError', translation: 'The file you are trying to upload is not an image' },
      { key: '_list', translation: 'List' },
      { key: '_deleteComponent', translation: 'Component will be deleted' },
      { key: '_showText', translation: 'Show text' },
      { key: '_exportAsZPL', translation: 'Export as ZPL' },
      { key: '_errorExporting', translation: 'Error exporting' },
      { key: '_exportSuccessfully', translation: 'Export successfully' },
      { key: '_zplLabelCode', translation: 'ZPL Code' },
      { key: '_notValidInput', translation: 'is not a valid input for' },
      { key: '_copied', translation: 'Copied' },
      { key: '_description', translation: 'Description' },
      { key: '_clearLabel', translation: 'Clear Label' },
      { key: '_pdf417Error', translation: 'PDF417 must contain only digits, capital letters, spaces and the symbols -.$/+%' },
      { key: '_addNewDescription', translation: 'Add new Description to the label' },
      { key: '_required', translation: 'Required' },
      { key: '_saveRequiredValuesAlert', translation: 'To save enter the required values' },
      { key: '_inverse', translation: 'Inverse' },
      { key: '_changesWithoutSaving', translation: 'You may have changes without saving!' },
      { key: '_name', translation: 'Name' },
      { key: '_value', translation: 'Value' }
    ],
    loading: true,
    exportedPdf: '',
    saveLoading: false,
    showImportJson: false,
    importedJsonDialog: undefined
  },
  methods: {
    async initialize () {
      LookingImage()
      await this.getTranslations()
      await this.getPurposes()
    },
    actualizar (id) {
      vueInstance.data2.lastActionSave = false
      actualizar(id)
    },
    changeNameFunc () {
      vueInstance.data2.lastActionSave = false
      changeName(vueInstance.data2.selectedItem.id)
    },
    deleteItem () {
      vueInstance.data2.showConfirmationDialog = false
      Delete(vueInstance.data2.selectedItem.id)
    },
    moreThanOneAlert () {
      MoreThanOneAlert(vueInstance.data2.multiSelected.id, 'single')
    },
    clearCanvasDialog () {
      vueInstance.data2.lastActionSave = false
      clearCanvas()
    },
    changeCanvasSizeDialog () {
      vueInstance.data2.lastActionSave = false
      ChangeCanvasSize()
    },
    exportDialog () {
      vueInstance.data2.lastActionSave = true
      Export()
    },
    changeModeDialog () {
      ChangeMode()
    },
    importImageDialog () {
      ImportImage()
    },
    async importJsonDialog () {
      if (vueInstance.data2.importedJsonDialog.type === 'application/json') {
        clearCanvas()
        const fr = new FileReader()

        fr.addEventListener('load', e => {
          var obj = JSON.parse(fr.result)
          vueInstance.data2.canvasHeightDialog = obj.CanvasHeight
          vueInstance.data2.canvasWidthDialog = obj.CanvasWidth

          ChangeCanvasSize()

          for (var cont = 0; cont < obj.Objects.length; cont++) {
            var variable = (JSON.parse(obj.Objects[cont].Content))

            switch (variable.type) {
              case 'line':
                drawLine(0, 0, 0, true, 0)
                break
              case 'square':
                drawSquare(0, 0, 0, 0, 0)
                break
              case 'text':
                drawText(0, 0, 'Sample', 0, 'Arial', 0)
                break
              case 'code':
                drawCode(0, 0, 0, 0, 0, 'CODE128', 'Sample')
                break
              case 'image':
                drawImage(0, 0, 0, 0)
                break
              default:
                break
            }

            lista[identificador - 1].Importar(variable)
          }
          diselect()
          redraw(-1)
        })

        fr.readAsText(vueInstance.data2.importedJsonDialog)
      } else {
        vueInstance.data2.snackbar.color = 'red'
        vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_labelImportedError')
        vueInstance.data2.showSnackbar = true
      }
    },
    importDialog () {
      Import(vueInstance.data2.etiquetaID)
    },
    addNewNameValue () {
      var newName = vueInstance.data2.newName
      var newValue = vueInstance.data2.newValue
      var nameValue = {
        Type: newName,
        Value: newValue
      }
      vueInstance.data2.purposes.push(nameValue)
      vueInstance.data2.newName = ''
      vueInstance.data2.newValue = ''
    },
    deleteNameValue (item) {
      var indexOfItem = vueInstance.data2.purposes.indexOf(item)
      vueInstance.data2.purposes.splice(indexOfItem, 1)
    },
    selectItemById (id) {
      vueInstance.data2.selectedItem = lista.filter(element => element.id === id)[0]
      // Aquí van los métodos para reinciar las variables
      this.changeTypeOfCode()
      this.changeDirectionVer()
      this.changeText()
      this.changeMagnetic()
      this.changeShow()
      this.imageFromChange()
      this.changeSelectedImage()
    },
    diselectItem () {
      diselect()
    },
    deselectItem () {
      this.fixNegativeValues()
      vueInstance.data2.selectedItem = {}
    },
    fixNegativeValues () {
      if (vueInstance.data2.selectedItem.type === 'line' && vueInstance.data2.selectedItem.length < 0) {
        if (vueInstance.data2.selectedItem.length < 0 && vueInstance.data2.selectedItem.orientation) {
          vueInstance.data2.selectedItem.x += vueInstance.data2.selectedItem.length
          vueInstance.data2.selectedItem.length *= -1
        }
        if (vueInstance.data2.selectedItem.length < 0 && !vueInstance.data2.selectedItem.orientation) {
          vueInstance.data2.selectedItem.y += vueInstance.data2.selectedItem.length
          vueInstance.data2.selectedItem.length *= -1
        }
        actualizar(vueInstance.data2.selectedItem.id)
        redraw(vueInstance.data2.selectedItem.id)
      } else if (vueInstance.data2.selectedItem.type === 'square' && (vueInstance.data2.selectedItem.width < 0 || vueInstance.data2.selectedItem.height < 0)) {
        if (vueInstance.data2.selectedItem.width < 0) {
          vueInstance.data2.selectedItem.x += vueInstance.data2.selectedItem.width
          vueInstance.data2.selectedItem.width *= -1
        }
        if (vueInstance.data2.selectedItem.height < 0) {
          vueInstance.data2.selectedItem.y += vueInstance.data2.selectedItem.height
          vueInstance.data2.selectedItem.height *= -1
        }
        actualizar(vueInstance.data2.selectedItem.id)
        redraw(vueInstance.data2.selectedItem.id)
      }
    },
    changeSelectedImage () {
      if (vueInstance.data2.preselectedImages !== undefined && vueInstance.data2.importedImages !== undefined) {
        vueInstance.data2.selectedImage = vueInstance.data2.selectedItem.predefined ? vueInstance.data2.preselectedImages.filter(element => element.name === vueInstance.data2.selectedItem.selected)[0] : vueInstance.data2.importedImages.filter(element => element.name === vueInstance.data2.selectedItem.selected)[0]
      }
    },
    changeTypeOfCode () {
      vueInstance.data2.typeOfCode = vueInstance.data2.selectedItem.barcodeType
    },
    changeDirectionVer () {
      if (!vueInstance.data2.selectedItem.orientation) {
        vueInstance.data2.ver = 'Vertical'
      } else {
        vueInstance.data2.ver = 'Horizontal'
      }
    },
    selectItem (id) {
      this.fixNegativeValues()
      select(id)
    },
    changeDirection () {
      if (vueInstance.data2.ver === 'Vertical') {
        vueInstance.data2.selectedItem.orientation = false
      } else {
        vueInstance.data2.selectedItem.orientation = true
      }
      actualizar(vueInstance.data2.selectedItem.id)
    },
    changeTextType () {
      if (vueInstance.data2.textType === 'Etiqueta') {
        vueInstance.data2.selectedItem.placeholder = true
      } else {
        vueInstance.data2.selectedItem.placeholder = false
      }
      actualizar(vueInstance.data2.selectedItem.id)
    },
    changeText () {
      if (vueInstance.data2.selectedItem.placeholder) {
        vueInstance.data2.textType = 'Etiqueta'
      } else {
        vueInstance.data2.textType = 'Texto'
      }
    },
    changeMagneticType () {
      if (vueInstance.data2.magnetic === 'Enabled') {
        vueInstance.data2.selectedItem.magnet = true
      } else {
        vueInstance.data2.selectedItem.magnet = false
      }
      actualizar(vueInstance.data2.selectedItem.id)
    },
    changeMagnetic () {
      if (vueInstance.data2.selectedItem.magnet) {
        vueInstance.data2.magnetic = 'Enabled'
      } else {
        vueInstance.data2.magnetic = 'Disabled'
      }
    },
    showChange () {
      vueInstance.data2.lastActionSave = false
      if (vueInstance.data2.show) {
        show(vueInstance.data2.selectedItem.id)
      } else {
        hide(vueInstance.data2.selectedItem.id)
      }
    },
    changeShow () {
      if (vueInstance.data2.selectedItem.visible) {
        vueInstance.data2.show = true
      } else {
        vueInstance.data2.show = false
      }
    },
    changeImageFrom () {
      if (vueInstance.data2.image === 'Predefined') {
        vueInstance.data2.selectedItem.predefined = true
      } else {
        vueInstance.data2.selectedItem.predefined = false
      }
      actualizar(vueInstance.data2.selectedItem.id)
    },
    imageFromChange () {
      if (vueInstance.data2.selectedItem.predefined) {
        vueInstance.data2.image = 'Predefined'
      } else {
        vueInstance.data2.image = 'Imported'
      }
    },
    importAsJson () {
      vueInstance.data2.importedJsonDialog = undefined
      vueInstance.data2.showImportJson = true
    },
    async exportToJson () {
      var ObjectList = []
      ObjectList.length = 0
      for (var i = 0; i < lista.length; i++) {
        var Info = lista[i].Exportar()
        ObjectList.push(Info)
      }
      var EntregaData = { 'Name': 'Label', 'Objects': ObjectList, 'CanvasWidth': vueInstance.data2.canvasWidthDialog, 'CanvasHeight': vueInstance.data2.canvasHeightDialog }
      var dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(EntregaData))
      var downloadAnchorNode = document.createElement('a')
      downloadAnchorNode.setAttribute('href', dataStr)
      downloadAnchorNode.setAttribute('download', 'newLabel.json')
      downloadAnchorNode.click()
    },
    showZplLabelDialogTooltip () {
      if (vueInstance.data2.showTooltipZplLabelDialog === false) {
        vueInstance.data2.showTooltipZplLabelDialog = true
        setTimeout(function () { vueInstance.data2.showTooltipZplLabelDialog = false }, 1000)
      }
    },
    async saveExistentLabel () {
      vueInstance.data2.lastActionSave = true
      var ObjectList = []
      ObjectList.length = 0
      for (var i = 0; i < lista.length; i++) {
        var Info = lista[i].Exportar()
        ObjectList.push(Info)
      }

      if (vueInstance.data2.newName && vueInstance.data2.newValue) {
        var newNameValue = {
          Type: vueInstance.data2.newName,
          Value: vueInstance.data2.newValue
        }
        vueInstance.data2.newName = ''
        vueInstance.data2.newValue = ''
        vueInstance.data2.purposes.push(newNameValue)
      }

      this.saveLoading = true

      var data = { 'Label': { 'id': vueInstance.data2.etiquetaID, 'Name': vueInstance.data2.saveNameDialog, 'Objects': ObjectList, 'Description': vueInstance.data2.labelDescription, 'CanvasWidth': vueInstance.data2.canvasWidthDialog, 'CanvasHeight': vueInstance.data2.canvasHeightDialog }, 'Purposes': vueInstance.data2.purposes }
      await LabelDesignerService.saveNewLabelVersion(vueInstance.data2.etiquetaID, data).then(res => {
        if (res.request.status === 200 || res.request.status === 201) {
          vueInstance.data2.snackbar.color = 'green'
          vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_labelSaved')
          vueInstance.data2.showSnackbar = true
          vueInstance.data2.etiquetaID = res.data.id
        } else {
          vueInstance.data2.snackbar.color = 'red'
          vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_labelSavedError')
          vueInstance.data2.showSnackbar = true
        }
        this.saveLoading = false
      })
    },
    dibujarLinea () {
      if (vueInstance.data2.selectedItem !== undefined) {
        this.fixNegativeValues()
      }
      drawLine(0, 0, 200, false, 2)
      vueInstance.data2.lastActionSave = false
    },
    dibujarSquare () {
      if (vueInstance.data2.selectedItem !== undefined) {
        this.fixNegativeValues()
      }
      drawSquare(0, 0, 300, 300, 2)
      vueInstance.data2.lastActionSave = false
    },
    dibujarText (etiqueta) {
      if (vueInstance.data2.selectedItem !== undefined) {
        this.fixNegativeValues()
      }
      drawText(0, 20, 'Sample', 12, 'Arial', 0, etiqueta)
      vueInstance.data2.lastActionSave = false
    },
    dibujarCode () {
      if (vueInstance.data2.selectedItem !== undefined) {
        this.fixNegativeValues()
      }
      drawCode(100, 100, 0, 2, 100, 'CODE128', 'Sample')
      vueInstance.data2.lastActionSave = false
    },
    dibujarImage () {
      if (vueInstance.data2.selectedItem !== undefined) {
        this.fixNegativeValues()
      }
      drawImage(0, 0, 100, 100)
      vueInstance.data2.lastActionSave = false
    },
    cancelDeleteDialog () {
      if (vueInstance.data2.selectedItem !== undefined) {
        this.fixNegativeValues()
      }
      this.showConfirmationDialog = false
      this.itemToDelete = ''
    },
    cancelDeleteDialog2 () {
      vueInstance.data2.next(false)
      this.showConfirmationDialog2 = false
    },
    exitPage () {
      vueInstance.data2.next()
      this.showConfirmationDialog2 = false
    },
    exportLabel () {
      if (vueInstance.data2.selectedItem !== undefined) {
        this.fixNegativeValues()
      }
      ExportZpl()
    },
    async exportToPDF () {
      if (vueInstance.data2.selectedItem !== undefined) {
        this.fixNegativeValues()
      }
      await ExportPDF().then(() => {
        var bin = _base64ToArrayBuffer(vueInstance.data2.exportedPdf)
        var file = new Blob([bin], { type: 'application/pdf' })
        var fileURL = URL.createObjectURL(file)
        // window.open(fileURL)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = fileURL
        // the filename you want
        a.download = 'labelPDF.pdf'
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(fileURL)
      })
    },
    getBarCodeOrientationIcon (orientation) {
      switch (orientation) {
        case 0:
          return 'arrow_upward'
        case 90:
          return 'arrow_forward'
        case 180:
          return 'arrow_downward'
        case 270:
          return 'arrow_back'
        default:
          return ''
      }
    },
    getOrientationIcon (orientation) {
      switch (orientation) {
        case 0:
          return 'arrow_upward'
        case 90:
          return 'arrow_back'
        case 180:
          return 'arrow_downward'
        case 270:
          return 'arrow_forward'
        default:
          return ''
      }
    },
    async getTranslations () {
      if (this.$root.$data.user.profile !== undefined) {
        await translationsService.get('Labeling_LabelDesigner', this.$root.$data.user.profile['customclaim-language']).then(res => {
          this.translations = res.data
        })
      }
    },
    getTranslated (key) {
      var translation = vueInstance.data2.translations.filter(element => element.key === key)
      if (translation.length > 0) {
        return translation[0].translation
      } else {
        return 'Translation Error: ' + key
      }
    },
    async getPurposes () {
      await LabelDesignerService.getPurposes().then(res => {
        this.purposesList = res.data
      })
    }
  },
  async created () {
    await this.initialize()
    vueInstance.data2.loading = false
    vueInstance.data2.isVariableName = ''
    vueInstance.data2.purposes = []
    if (this.$route.params.id !== undefined && this.$route.params.version !== undefined) {
      Import(this.$route.params.id, this.$route.params.version)
      vueInstance.data2.etiquetaID = this.$route.params.id
      vueInstance.data2.etiquetaVersion = this.$route.params.version
    } else {
      vueInstance.data2.showSnackbar = false
      vueInstance.data2.etiquetaID = ''
      clearCanvas()
    }
    if (this.buttonModeText === 'edition') {
      this.buttonModeText = this.getTranslated('_edition')
    }
  },
  mounted () {
    if (vueInstance.data2.lista.length > 0) {
      vueInstance.data2.lista.forEach(element => {
        redraw(element.id)
      })
      diselect()
    }
  }
}

export default vueInstance

/* eslint-disable */

/*
Nota: Para utilizar las funciones de Código de barras he descargado una libreria
    que se debera llamar antes que este documento en el archivo html

He intentado comentar cada función con alguna pequeña explicación de su funcionamiento, las funciones de mantenimiento son las primeras en aparecer.
*/
/*
* APARTADO DE VARIABLES
*/
// Variables Big, información bàsica de la etiqueta

var BigId = 0
var BigName = ''

// Tamaño del Canvas en el que se dibujan los objetos
var canvasWidth = 600
var canvasHeight = 700

// Distancia del borde de la pantalla superior e izquierdo al canvas
var canvasX = 75
var canvasY = 160

// Variables de comportamiento global
var MagneticField = 7 //  Distancia en px a la que se pegaran los componentes magneticos (Actualmente solo texto a 0º)
var MarginLines = 4 //  Margenes extra para facilitar el seleccionar lineas delgadas (cuadrados, lineas, etc)

// Variables de almacenamiento de datos
var identificador = 0 // Contador con el numero de items que se van generan (nunca decrece i actua como un id para cada objeto)
var isEdition = true
var lista = [] //  Lista de objetos que conforman la etiqueta
var multiChoiceList = [] //  Lista de Objetos que se seleccionan cuando se hace un multi-select (Ctrl + Click Izq. sobre diversos objetos)
var Selecting = [] // Lista para cuando los objetos se superponen y no se sabe que objeto seleccionar
var MultipleSelection = true //  Variable para entrar en el modo multiselección
var apply = true //  Variable para canviar las posiciones de Diferencial (al mover uno o más objetos a una nueva posición arrastrandolos)
var PosSel = -1 //  Variable para guardar la posición en la lista del objeto seleccionado actualmente
var Copy = null // Variable para guardar un objeto para copiar posteriormente

// Variables para almacenar la posición del ratón en todo momento
var PosX
var PosY

var sheet = (function () { // Código para crear una hoja de estilos CSS de manera dinamica (Usada para modificar las propiedades de los códigos de barras)
  var style = document.createElement('style')
  style.appendChild(document.createTextNode(''))
  document.head.appendChild(style)
  return style.sheet
})()

/*
Aquí empiezan las funciones, encargadas del comportamieno de la aplicación
    Las funciones con el simbolo *<CH>* son aquellas que son más sensibles a tocar en caso de mantenimiento simple.
*/

/*
*   FUNCIONES DRAW  *<CH>*
*       Funciones que crean un objeto del tipo estimado y cargan sus funciones de control y los datos necesarios
        Cada objeto nuevo necesitaria una nueva función.
        Si se quiere inclir un nuevo objeto se deberia añadir una nueva función personalizada.
*/
function drawLine (X, Y, length, Orientation, Thickness) { // *<CH>*
  var Linea = {
    id: identificador,
    type: 'line',
    x: X,
    y: Y,
    length: length,
    orientation: Orientation,
    thickness: Thickness,
    visible: true,
    DiffX: 0,
    DiffY: 0,
    name: 'line',
    mousemove: function () {
      var XX, YY
      if (!this.orientation) {
        XX = Math.round(PosX - this.DiffX)
        YY = Math.round(PosY - this.DiffY)
        if (XX >= canvasWidth) { XX = canvasWidth } //  El orden al analizar los bordes es importante cuando el objeto es más grande que el lienzo
        if (XX <= 0) { XX = 0 }
        if (YY + this.length > canvasHeight) { YY = canvasHeight - this.length }
        if (YY <= 0) { YY = 0 }
        this.x = XX
        this.y = YY
        this.S = YY
        this.I = YY + this.length
        this.L = XX - (this.thickness / 2 + MarginLines)
        this.R = XX + (this.thickness / 2 + MarginLines)
      } else {
        XX = Math.round(PosX - this.DiffX)
        YY = Math.round(PosY - this.DiffY)
        if (XX + this.length >= canvasWidth) { XX = canvasWidth - this.length } //  El orden al analizar los bordes es importante cuando el objeto es más grande que el lienzo
        if (XX <= 0) { XX = 0 }
        if (YY > canvasHeight) { YY = canvasHeight }
        if (YY <= 0) { YY = 0 }
        this.x = XX
        this.y = YY
        this.S = YY - (this.thickness / 2 + MarginLines)
        this.I = YY + (this.thickness / 2 + MarginLines)
        this.L = XX
        this.R = XX + this.length
      }
    },
    mousedown: function () {
      var green = false
      if (this.x - 3 < PosX && PosX < this.x + 3 && this.y - 3 < PosY && PosY < this.y + 3 && mousedownID == -1) {
        mousedownID = setInterval(this.whilemousedown_line1, 25)
        green = true
      }
      if (!this.orientation) {
        if (this.x - 3 < PosX && PosX < this.x + 3 && this.y - 3 + this.length < PosY && PosY < this.y + 3 + this.length && mousedownID == -1) {
          mousedownID = setInterval(this.whilemousedown_line2, 25)
          green = true
        }
      } else {
        if ((this.x + this.length - 3) < PosX && PosX < (this.x + 3 + this.length) && this.y - 3 < PosY && PosY < this.y + 3 && mousedownID == -1) {
          mousedownID = setInterval(this.whilemousedown_line2, 25)
          green = true
        }
      }
      if (!green) {
        mousedownID = setInterval(whilemousedown, 25) // execute every 25ms
      }
    },
    whilemousedown_line1: function () {
      if (!lista[PosSel].orientation) {
        if (PosY > lista[PosSel].y) {
          lista[PosSel].length = Math.round(lista[PosSel].length - (PosY - lista[PosSel].y))
        } else {
          lista[PosSel].length = Math.round(lista[PosSel].length + (lista[PosSel].y - PosY))
        }
        lista[PosSel].y = Math.round(PosY)
        lista[PosSel].S = PosY
      } else {
        if (PosX > lista[PosSel].x) {
          lista[PosSel].length = Math.round(lista[PosSel].length - (PosX - lista[PosSel].x))
        } else {
          lista[PosSel].length = Math.round(lista[PosSel].length + (lista[PosSel].x - PosX))
        }
        lista[PosSel].x = Math.round(PosX)
        lista[PosSel].L = PosX
      }
      redraw(lista[PosSel].id)
    },
    whilemousedown_line2: function () {
      if (!lista[PosSel].orientation) {
        lista[PosSel].length = Math.round(PosY - lista[PosSel].y)
        lista[PosSel].I = PosY
      } else {
        lista[PosSel].length = Math.round(PosX - lista[PosSel].x)
        lista[PosSel].R = PosX
      }
      redraw(lista[PosSel].id)
    },
    actualitzar: function () {
      var canvas = document.getElementById('CANVAS')
      this.x = parseInt(vueInstance.data2.selectedItem.x)
      this.y = parseInt(vueInstance.data2.selectedItem.y)
      this.length = parseInt(vueInstance.data2.selectedItem.length)
      this.orientation = vueInstance.data2.selectedItem.orientation
      this.thickness = parseInt(vueInstance.data2.selectedItem.thickness)
      if (this.orientation) {
        this.S = this.y - (this.thickness / 2 + MarginLines)
        this.I = this.y + (this.thickness / 2 + MarginLines)
        this.L = this.x
        this.R = this.x + this.length
      } else {
        this.S = this.y
        this.I = this.y + this.length
        this.L = this.x - (this.thickness / 2 + MarginLines)
        this.R = this.x + (this.thickness / 2 + MarginLines)
      }
      this.xMax = JSON.parse(this.orientation) ? canvas.offsetWidth - this.length : canvas.offsetWidth - this.thickness
      this.yMax = JSON.parse(this.orientation) ? canvas.offsetHeight - this.thickness : canvas.offsetHeight - this.length
    },
    draw: function (ID) {
      var canvas = document.getElementById('CANVAS')
      var ctx = canvas.getContext('2d')
      ctx.beginPath()
      ctx.lineWidth = this.thickness
      //  Canvi de color item seleccionat
      if (ID === this.id) {
        ctx.strokeStyle = 'red'
      } else if (this.multiChoice) {
        ctx.strokeStyle = 'green'
      } else {
        ctx.strokeStyle = 'black'
      }
      ctx.moveTo(this.x, this.y)
      if (!this.orientation) {
        ctx.lineTo(this.x, this.y + this.length)
      } else {
        ctx.lineTo(this.x + this.length, this.y)
      }
      ctx.stroke()
      if (ID === this.id) {
        ctx.fillStyle = 'green'
        ctx.rect(this.x - 3, this.y - 3, 6, 6)
        ctx.fill()
        if (!this.orientation) {
          ctx.rect(this.x - 3, this.y - 3 + this.length, 6, 6)
        } else {
          ctx.rect(this.x - 3 + this.length, this.y - 3, 6, 6)
        }
        ctx.fill()
      }
    },
    Exportar: function () {
      var superData
      superData = {
        type: this.type,
        x: this.x,
        y: this.y,
        length: this.length,
        orientation: this.orientation,
        thickness: this.thickness,
        visible: this.visible,
        name: this.name
      }
      return { 'ObjectID': this.id, 'ObjectClass': this.type, 'Content': JSON.stringify(superData) }
    },
    Importar: function (instancia) {
      if (instancia.type === 'line') {
        this.x = instancia.x
        this.y = instancia.y
        this.length = instancia.length
        this.orientation = instancia.orientation
        this.thickness = instancia.thickness
        this.visible = instancia.visible
        this.name = instancia.name
        if (instancia.orientation) {
          this.S = instancia.y - (instancia.thickness / 2 + MarginLines)
          this.I = instancia.y + (instancia.thickness / 2 + MarginLines)
          this.L = instancia.x
          this.R = instancia.x + instancia.length
        } else {
          this.S = instancia.y
          this.I = instancia.y + instancia.length
          this.L = instancia.x - (instancia.thickness / 2 + MarginLines)
          this.R = instancia.x + (instancia.thickness / 2 + MarginLines)
        }
      }
    },
    S: 0,
    I: 0,
    L: 0,
    R: 0,
    multiChoice: false
  }
  if (Orientation) {
    Linea.S = Y - (Thickness / 2 + MarginLines)
    Linea.I = Y + (Thickness / 2 + MarginLines)
    Linea.L = X
    Linea.R = X + length
  } else {
    Linea.S = Y
    Linea.I = Y + length
    Linea.L = X - (Thickness / 2 + MarginLines)
    Linea.R = X + (Thickness / 2 + MarginLines)
  }
  Linea.name = 'line ' + Linea.id
  lista.push(Linea)

  select(identificador)
  identificador++
  vueInstance.data2.lista = lista
}
function drawSquare (X, Y, Width, Height, Thickness) { // *<CH>*
  var Square = {
    id: identificador,
    type: 'square',
    x: X,
    y: Y,
    width: Width,
    height: Height,
    xMax: '',
    yMax: '',
    thickness: Thickness,
    visible: true,
    DiffX: 0,
    DiffY: 0,
    name: 'Square',
    mousemove: function () {
      var canvas = document.getElementById('CANVAS')
      this.xMax = canvas.offsetWidth - this.width
      this.yMax = canvas.offsetHeight - this.height
      var XX = Math.round(PosX - this.DiffX)
      var YY = Math.round(PosY - this.DiffY)
      if (XX + this.width >= canvasWidth) { XX = canvasWidth - this.width } //  El orden al analizar los bordes es importante cuando el objeto es más grande que el lienzo
      if (YY + this.height > canvasHeight) { YY = canvasHeight - this.height }
      if (XX <= 0) { XX = 0 }
      if (YY <= 0) { YY = 0 }
      this.x = XX
      this.y = YY
      this.S = YY - (this.thickness / 2 + MarginLines)
      this.I = YY + this.height + (this.thickness / 2 + MarginLines)
      this.L = XX - (this.thickness / 2 + MarginLines)
      this.R = XX + this.width + (this.thickness / 2 + MarginLines)
      this.S2 = YY + (this.thickness / 2 + MarginLines)
      this.I2 = YY + this.height - (this.thickness / 2 + MarginLines)
      this.L2 = XX + (this.thickness / 2 + MarginLines)
      this.R2 = XX + this.width - (this.thickness / 2 + MarginLines)
    },
    mousedown: function () {
      var green = false
      if (this.x - 3 < PosX && PosX < this.x + 3 && this.y - 3 < PosY && PosY < this.y + 3 && mousedownID == -1) {
        mousedownID = setInterval(this.whilemousedown_square1, 25)
        green = true
      }
      if (this.x - 3 + this.width < PosX && PosX < this.x + 3 + this.width && this.y - 3 < PosY && PosY < this.y + 3 && mousedownID == -1) {
        mousedownID = setInterval(this.whilemousedown_square2, 25)
        green = true
      }
      if (this.x - 3 + this.width < PosX && PosX < this.x + 3 + this.width && this.y - 3 + this.height < PosY && PosY < this.y + 3 + this.height && mousedownID == -1) {
        mousedownID = setInterval(this.whilemousedown_square3, 25)
        green = true
      }
      if (this.x - 3 < PosX && PosX < this.x + 3 && this.y - 3 + this.height < PosY && PosY < this.y + 3 + this.height && mousedownID == -1) {
        mousedownID = setInterval(this.whilemousedown_square4, 25)
        green = true
      }
      if (!green) {
        mousedownID = setInterval(whilemousedown, 25)
      }
    },
    whilemousedown_square1: function () {
      if (PosY > lista[PosSel].y) {
        lista[PosSel].height = Math.round(lista[PosSel].height - (PosY - lista[PosSel].y))
      } else {
        lista[PosSel].height = Math.round(lista[PosSel].height + (lista[PosSel].y - PosY))
      }
      if (PosX > lista[PosSel].x) {
        lista[PosSel].width = Math.round(lista[PosSel].width - (PosX - lista[PosSel].x))
      } else {
        lista[PosSel].width = Math.round(lista[PosSel].width + (lista[PosSel].x - PosX))
      }
      lista[PosSel].x = Math.round(PosX)
      lista[PosSel].y = Math.round(PosY)
      lista[PosSel].S = PosY - lista[PosSel].thickness / 2 + MarginLines
      lista[PosSel].S2 = PosY + lista[PosSel].thickness / 2 + MarginLines
      lista[PosSel].L = PosX - lista[PosSel].thickness / 2 + MarginLines
      lista[PosSel].L2 = PosX + lista[PosSel].thickness / 2 + MarginLines
      redraw(lista[PosSel].id)
    },
    whilemousedown_square2: function () {
      if (PosY > lista[PosSel].y) {
        lista[PosSel].height = Math.round(lista[PosSel].height - (PosY - lista[PosSel].y))
      } else {
        lista[PosSel].height = Math.round(lista[PosSel].height + (lista[PosSel].y - PosY))
      }
      if (PosX > lista[PosSel].x) {
        lista[PosSel].width = Math.round(lista[PosSel].width + (PosX - lista[PosSel].x - lista[PosSel].width))
      } else {
        lista[PosSel].width = Math.round(lista[PosSel].width - (lista[PosSel].x + lista[PosSel].width - PosX))
      }
      lista[PosSel].x = Math.round(PosX - lista[PosSel].width)
      lista[PosSel].y = Math.round(PosY)

      lista[PosSel].S = PosY - lista[PosSel].thickness / 2 + MarginLines
      lista[PosSel].S2 = PosY + lista[PosSel].thickness / 2 + MarginLines
      lista[PosSel].R = PosX + lista[PosSel].thickness / 2 + MarginLines
      lista[PosSel].R2 = PosX - lista[PosSel].thickness / 2 + MarginLines
      redraw(lista[PosSel].id)
    },
    whilemousedown_square3: function () {
      if (PosY > lista[PosSel].y) {
        lista[PosSel].height = Math.round(lista[PosSel].height + (PosY - lista[PosSel].y - lista[PosSel].height))
      } else {
        lista[PosSel].height = Math.round(lista[PosSel].height - (lista[PosSel].y + lista[PosSel].height - PosY))
      }
      if (PosX > lista[PosSel].x) {
        lista[PosSel].width = Math.round(lista[PosSel].width + (PosX - lista[PosSel].x - lista[PosSel].width))
      } else {
        lista[PosSel].width = Math.round(lista[PosSel].width - (lista[PosSel].x + lista[PosSel].width - PosX))
      }
      lista[PosSel].x = Math.round(PosX - lista[PosSel].width)
      lista[PosSel].y = Math.round(PosY - lista[PosSel].height)
      lista[PosSel].I = PosY + lista[PosSel].thickness / 2 + MarginLines
      lista[PosSel].I2 = PosY - lista[PosSel].thickness / 2 + MarginLines
      lista[PosSel].R = PosX + lista[PosSel].thickness / 2 + MarginLines
      lista[PosSel].R2 = PosX - lista[PosSel].thickness / 2 + MarginLines
      redraw(lista[PosSel].id)
    },
    whilemousedown_square4: function () {
      if (PosY > lista[PosSel].y) {
        lista[PosSel].height = Math.round(lista[PosSel].height + (PosY - lista[PosSel].y - lista[PosSel].height))
      } else {
        lista[PosSel].height = Math.round(lista[PosSel].height - (lista[PosSel].y + lista[PosSel].height - PosY))
      }
      if (PosX > lista[PosSel].x) {
        lista[PosSel].width = Math.round(lista[PosSel].width - (PosX - lista[PosSel].x))
      } else {
        lista[PosSel].width = Math.round(lista[PosSel].width + (lista[PosSel].x - PosX))
      }
      lista[PosSel].x = Math.round(PosX)
      lista[PosSel].y = Math.round(PosY - lista[PosSel].height)
      lista[PosSel].I = PosY + lista[PosSel].thickness / 2 + MarginLines
      lista[PosSel].I2 = PosY - lista[PosSel].thickness / 2 + MarginLines
      lista[PosSel].L = PosX - lista[PosSel].thickness / 2 + MarginLines
      lista[PosSel].L2 = PosX + lista[PosSel].thickness / 2 + MarginLines
      redraw(lista[PosSel].id)
    },
    actualitzar: function () {
      var canvas = document.getElementById('CANVAS')
      this.x = parseInt(vueInstance.data2.selectedItem.x)
      this.y = parseInt(vueInstance.data2.selectedItem.y)
      this.width = parseInt(vueInstance.data2.selectedItem.width)
      this.height = parseInt(vueInstance.data2.selectedItem.height)
      this.thickness = parseInt(vueInstance.data2.selectedItem.thickness)
      this.S = this.y - (this.thickness / 2 + MarginLines)
      this.I = this.y + this.height + (this.thickness / 2 + MarginLines)
      this.L = this.x - (this.thickness / 2 + MarginLines)
      this.R = this.x + this.width + (this.thickness / 2 + MarginLines)
      this.S2 = this.y + (this.thickness / 2 + MarginLines)
      this.I2 = this.y + this.height - (this.thickness / 2 + MarginLines)
      this.L2 = this.x + (this.thickness / 2 + MarginLines)
      this.R2 = this.x + this.width - (this.thickness / 2 + MarginLines)
      this.xMax = canvas.offsetWidth - this.width
      this.yMax = canvas.offsetHeight - this.height
    },
    draw: function (ID) {
      var canvas = document.getElementById('CANVAS')
      var ctx = canvas.getContext('2d')
      ctx.beginPath()
      //  Canvi de color item seleccionat
      if (ID === this.id) {
        ctx.strokeStyle = 'red'
      } else if (this.multiChoice) {
        ctx.strokeStyle = 'green'
      } else {
        ctx.strokeStyle = 'black'
      }
      ctx.rect(this.x, this.y, this.width, this.height)
      ctx.lineWidth = this.thickness
      ctx.stroke()
      if (ID === this.id) {
        ctx.beginPath()
        ctx.fillStyle = 'green'
        ctx.rect(this.x - 3, this.y - 3, 6, 6)
        ctx.fill()
        ctx.rect(this.x - 3 + this.width, this.y - 3, 6, 6)
        ctx.fill()
        ctx.rect(this.x - 3 + this.width, this.y - 3 + this.height, 6, 6)
        ctx.fill()
        ctx.rect(this.x - 3, this.y - 3 + this.height, 6, 6)
        ctx.fill()
      }
    },
    Exportar: function () {
      var superData
      superData = {
        type: this.type,
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        thickness: this.thickness,
        visible: this.visible,
        name: this.name
      }
      return { 'ObjectID': this.id, 'ObjectClass': this.type, 'Content': JSON.stringify(superData) }
    },
    Importar: function (instancia) {
      if (instancia.type === 'square') {
        this.x = instancia.x
        this.y = instancia.y
        this.width = instancia.width
        this.height = instancia.height
        this.thickness = instancia.thickness
        this.visible = instancia.visible
        this.name = instancia.name
        this.S = instancia.y - (instancia.thickness / 2 + MarginLines)
        this.I = instancia.y + instancia.height + (instancia.thickness / 2 + MarginLines)
        this.L = instancia.x - (instancia.thickness / 2 + MarginLines)
        this.R = instancia.x + instancia.width + (instancia.thickness / 2 + MarginLines)
        this.S2 = instancia.y + (instancia.thickness / 2 + MarginLines)
        this.I2 = instancia.y + instancia.height - (instancia.thickness / 2 + MarginLines)
        this.L2 = instancia.x + (instancia.thickness / 2 + MarginLines)
        this.R2 = instancia.x + instancia.width - (instancia.thickness / 2 + MarginLines)
      }
    },
    S: Y - (Thickness / 2 + MarginLines),
    I: Y + Height + (Thickness / 2 + MarginLines),
    L: X - (Thickness / 2 + MarginLines),
    R: X + Width + (Thickness / 2 + MarginLines),
    S2: Y + (Thickness / 2 + MarginLines),
    I2: Y + Height - (Thickness / 2 + MarginLines),
    L2: X + (Thickness / 2 + MarginLines),
    R2: X + Width - (Thickness / 2 + MarginLines),
    multiChoice: false
  }
  Square.name = 'square ' + Square.id
  lista.push(Square)

  select(identificador)
  identificador++
  vueInstance.data2.lista = lista
}
function drawText (X, Y, FieldName, FontSize, FontName, Orientation, placeholder) { // *<CH>*
  var canvas1 = document.getElementById('CANVAS')
  var contx = canvas1.getContext('2d')
  contx.font = FontSize + 'px ' + FontName
  var Texto = {
    id: identificador,
    type: 'text',
    x: X,
    y: Y,
    fieldName: FieldName,
    fontSize: FontSize,
    fontName: FontName,
    orientation: Orientation,
    // tag: 'true',
    visible: true,
    magnet: false,
    placeholder: placeholder,
    value: 'Example',
    DiffX: 0,
    DiffY: 0,
    name: 'FieldName',
    inverse: false,
    mousemove: function () { //  FUNCTION TO CHANGE -> Acabar de cambiar las cajas de selección on move de texto
      var canvas = document.getElementById('CANVAS')
      var ctx = canvas.getContext('2d')
      ctx.font = this.fontSize + 'px ' + this.fontName
      var XX = Math.round(PosX - this.DiffX)
      var YY = Math.round(PosY - this.DiffY)
      var texto = ''
      if (this.placeholder) {
        texto = ''
        if (isEdition) {
          texto = '<' + this.fieldName + '>'
        } else {
          texto = this.value
        }
      } else {
        texto = this.fieldName
      }
      if (this.orientation === 0) {
        if (XX + ctx.measureText(texto).width >= canvasWidth) { XX = canvasWidth - ctx.measureText(texto).width }
        if (YY + (this.fontSize * 1 / 4) > canvasHeight) { YY = canvasHeight - (this.fontSize * 1 / 4) }
        if (XX <= 0) { XX = 0 } //  El orden al analizar los bordes es importante cuando el objeto es más grande que el lienzo
        if (YY - (this.fontSize * 3 / 4) <= 0) { YY = (this.fontSize * 3 / 4) }
        this.x = Math.round(XX)
        this.y = Math.round(YY)
        this.S = YY - (this.fontSize * 3 / 4)
        this.I = YY
        this.L = XX
        this.R = XX + ctx.measureText(texto).width
        if (this.magnet) {
          for (var i = 0; i < lista.length; i++) {
            if (lista[i].type === 'text' && lista[i].visible && lista[i].orientation === 0 && lista[i].id !== this.id) {
              if (lista[i].S + MagneticField >= this.S && lista[i].S - MagneticField <= this.S) {
                this.y = Math.round(lista[i].S + (this.fontSize * 3 / 4))
                this.S = Math.round(lista[i].S)
                this.I = Math.round(lista[i].S + (this.fontSize * 3 / 4))
              } else if (lista[i].I + MagneticField >= this.I && lista[i].I - MagneticField <= this.I) {
                this.y = Math.round(lista[i].I)
                this.S = Math.round(lista[i].I - (this.fontSize * 3 / 4))
                this.I = Math.round(lista[i].I)
              } else if (lista[i].R + MagneticField >= this.L && lista[i].R - MagneticField <= this.L) {
                this.x = Math.round(lista[i].R)
                this.L = Math.round(lista[i].R)
                this.R = Math.round(lista[i].R + ctx.measureText(texto).width)
              } else if (lista[i].L + MagneticField >= this.R && lista[i].L - MagneticField <= this.R) {
                this.x = Math.round(lista[i].L - ctx.measureText(texto).width)
                this.R = Math.round(lista[i].L)
                this.L = Math.round(lista[i].L - ctx.measureText(texto).width)
              } else if (lista[i].L + MagneticField >= this.L && lista[i].L - MagneticField <= this.L) {
                this.x = Math.round(lista[i].L)
                this.R = Math.round(lista[i].L)
                this.L = Math.round(lista[i].L)
              } else if (lista[i].R + MagneticField >= this.R && lista[i].R - MagneticField <= this.R) {
                this.x = Math.round(lista[i].R - ctx.measureText(texto).width)
                this.R = Math.round(lista[i].R)
                this.L = Math.round(lista[i].R)
              }
            }
          }
        }
      } else if (this.orientation === 90) {
        if (XX + this.fontSize >= canvasWidth) { XX = canvasWidth - this.fontSize }
        if (YY + ctx.measureText(texto).width - (this.fontSize * 3 / 4) >= canvasHeight) { YY = canvasHeight - ctx.measureText(texto).width + (this.fontSize * 3 / 4) }
        if (XX <= 0) { XX = 0 } //  El orden al analizar los bordes es importante cuando el objeto es más grande que el lienzo
        if (YY - (this.fontSize * 3 / 4) <= 0) { YY = (this.fontSize * 3 / 4) }
        this.x = Math.round(XX)
        this.y = Math.round(YY)
        this.S = this.y - (this.fontSize * 3 / 4)
        this.L = this.x
        this.I = this.y + ctx.measureText(texto).width
        this.R = this.x + this.fontSize
        if (this.magnet) {
          for (var i = 0; i < lista.length; i++) {
            if (lista[i].type === 'text' && lista[i].visible && lista[i].orientation === 0 && lista[i].id !== this.id) {
              if (lista[i].S + MagneticField >= this.S && lista[i].S - MagneticField <= this.S) {
                this.y = Math.round(lista[i].S + (this.fontSize * 3 / 4))
                this.S = Math.round(lista[i].S)
                this.I = Math.round(lista[i].S + ctx.measureText(texto).width)
              }
              if (lista[i].I + MagneticField >= this.I && lista[i].I - MagneticField <= this.I) {
                this.y = Math.round(lista[i].I - ctx.measureText(texto).width)
                this.S = Math.round(lista[i].I)
                this.I = Math.round(lista[i].I)
              }
              if (lista[i].R + MagneticField >= this.L && lista[i].R - MagneticField <= this.L) {
                this.x = Math.round(lista[i].R)
                this.L = Math.round(lista[i].R)
                this.R = Math.round(lista[i].R + (this.fontSize * 3 / 4))
              }
              if (lista[i].L + MagneticField >= this.R && lista[i].L - MagneticField <= this.R) {
                this.x = Math.round(lista[i].L - (this.fontSize * 3 / 4))
                this.R = Math.round(lista[i].L)
                this.L = Math.round(lista[i].L - (this.fontSize * 3 / 4))
              }
              if (lista[i].L + MagneticField >= this.L && lista[i].L - MagneticField <= this.L) {
                this.x = Math.round(lista[i].L)
                this.R = Math.round(lista[i].L)
                this.L = Math.round(lista[i].L + (this.fontSize * 3 / 4))
              }
            }
          }
        }
      } else if (this.orientation === 180) {
        if (XX + ctx.measureText(texto).width >= canvasWidth) { XX = canvasWidth - ctx.measureText(texto).width }
        if (YY + (this.fontSize * 1 / 4) > canvasHeight) { YY = canvasHeight - (this.fontSize * 1 / 4) }
        if (XX <= 0) { XX = 0 } //  El orden al analizar los bordes es importante cuando el objeto es más grande que el lienzo
        if (YY - (this.fontSize * 3 / 4) <= 0) { YY = (this.fontSize * 3 / 4) }
        this.x = Math.round(XX)
        this.y = Math.round(YY)
        this.S = this.y - (this.fontSize * 3 / 4)
        this.L = this.x
        this.I = this.y + this.fontSize
        this.R = this.x + ctx.measureText(texto).width
        if (this.magnet) {
          for (var i = 0; i < lista.length; i++) {
            if (lista[i].type === 'text' && lista[i].visible && lista[i].orientation === 0 && lista[i].id !== this.id) {
              if (lista[i].S + MagneticField >= this.S && lista[i].S - MagneticField <= this.S) {
                this.y = Math.round(lista[i].S + (this.fontSize * 3 / 4))
                this.S = Math.round(lista[i].S)
                this.I = Math.round(lista[i].S + (this.fontSize * 3 / 4))
              }
              if (lista[i].I + MagneticField >= this.I && lista[i].I - MagneticField <= this.I) {
                this.y = Math.round(lista[i].I)
                this.S = Math.round(lista[i].I - (this.fontSize * 3 / 4))
                this.I = Math.round(lista[i].I)
              }
              if (lista[i].R + MagneticField >= this.L && lista[i].R - MagneticField <= this.L) {
                this.x = Math.round(lista[i].R)
                this.L = Math.round(lista[i].R)
                this.R = Math.round(lista[i].R + ctx.measureText(texto).width)
              }
              if (lista[i].L + MagneticField >= this.R && lista[i].L - MagneticField <= this.R) {
                this.x = Math.round(lista[i].L - ctx.measureText(texto).width)
                this.R = Math.round(lista[i].L)
                this.L = Math.round(lista[i].L - ctx.measureText(texto).width)
              }
              if (lista[i].L + MagneticField >= this.L && lista[i].L - MagneticField <= this.L) {
                this.x = Math.round(lista[i].L)
                this.R = Math.round(lista[i].L)
                this.L = Math.round(lista[i].L + ctx.measureText(texto).width)
              }
            }
          }
        }
      } else {
        if (XX + this.fontSize >= canvasWidth) { XX = canvasWidth - this.fontSize }
        if (YY + ctx.measureText(texto).width - (this.fontSize * 3 / 4) >= canvasHeight) { YY = canvasHeight - ctx.measureText(texto).width + (this.fontSize * 3 / 4) }
        if (XX <= 0) { XX = 0 } //  El orden al analizar los bordes es importante cuando el objeto es más grande que el lienzo
        if (YY - (this.fontSize * 3 / 4) <= 0) { YY = (this.fontSize * 3 / 4) }
        this.x = Math.round(XX)
        this.y = Math.round(YY)
        this.S = this.y - (this.fontSize * 3 / 4)
        this.L = this.x
        this.I = this.y + ctx.measureText(texto).width
        this.R = this.x + this.fontSize
      }
    },
    mousedown: function () {
      mousedownID = setInterval(whilemousedown, 25)
    },
    actualitzar: function () {
      this.x = parseInt(vueInstance.data2.selectedItem.x)
      this.y = parseInt(vueInstance.data2.selectedItem.y)
      this.fieldName = vueInstance.data2.selectedItem.fieldName
      this.fontSize = parseInt(vueInstance.data2.selectedItem.fontSize)
      this.fontName = vueInstance.data2.selectedItem.fontName
      this.orientation = parseInt(vueInstance.data2.selectedItem.orientation)
      this.magnet = vueInstance.data2.selectedItem.magnet
      this.inverse = vueInstance.data2.selectedItem.inverse

      if (this.placeholder) {
        this.value = vueInstance.data2.selectedItem.value
      }
      this.placeholder = vueInstance.data2.selectedItem.placeholder
      var canvas = document.getElementById('CANVAS')
      var ctx = canvas.getContext('2d')
      ctx.beginPath()
      ctx.font = this.fontSize + 'px ' + this.fontName
      var texto = ''
      if (this.placeholder) {
        texto = ''
        if (isEdition) {
          texto = '<' + this.fieldName + '>'
        } else {
          texto = this.value
        }
      } else {
        texto = this.fieldName
      }
      this.S = this.y - (this.fontSize * 3 / 4)
      this.L = this.x
      if (this.orientation === 0) {
        this.I = this.y + this.fontSize
        this.R = this.x + ctx.measureText(texto).width
      } else if (this.orientation === 90) {
        this.I = this.y + ctx.measureText(texto).width
        this.R = this.x + this.fontSize
      } else if (this.orientation === 180) {
        this.I = this.y + this.fontSize
        this.R = this.x + ctx.measureText(texto).width
      } else {
        this.I = this.y + ctx.measureText(texto).width
        this.R = this.x + this.fontSize
      }
    },
    draw: function (ID) {
      var canvas = document.getElementById('CANVAS')
      var ctx = canvas.getContext('2d')
      ctx.beginPath()
      //  Canvi de color item seleccionat
      if (ID === this.id) {
        ctx.fillStyle = 'red'
      } else if (this.multiChoice) {
        ctx.fillStyle = 'green'
      } else if (this.placeholder) {
        ctx.fillStyle = 'blue'
      } else {
        ctx.fillStyle = 'black'
      }
      ctx.font = this.fontSize + 'px ' + this.fontName
      ctx.textAlign = 'left'
      ctx.save() // El save es per tornar a la configuració normal del canvas despres de rotar-lo
      var rad = -(this.orientation * Math.PI) / 180
      var X = this.x
      var Y = this.y
      if (this.orientation === 90) { // Cambio en la funcionalidad de rotación para asemejarse a la de ZPL
        X = this.x + (this.fontSize * 3 / 4)
        Y = this.y + ctx.measureText(this.fieldName).width - (this.fontSize * 3 / 4)
      } else if (this.orientation === 180) {
        X = this.x + ctx.measureText(this.fieldName).width
        Y = this.y - (this.fontSize * 3 / 4) + (this.fontSize * 1 / 4) // Trampa para asemejar la cajetilla a ZPL
      } else if (this.orientation === 270) {
        X = this.x + (this.fontSize * 1 / 4)
        Y = this.y - (this.fontSize * 3 / 4)
      }
      ctx.translate(X, Y)
      ctx.rotate(rad)
      if (this.placeholder) {
        var texto = ''
        if (isEdition) {
          texto = '<' + this.fieldName + '>'
        } else {
          texto = this.value
        }
        ctx.fillText(texto, 0, 0)
      } else {
        ctx.fillText(this.fieldName, 0, 0)
      }
      ctx.restore()
    },
    Exportar: function () {
      var superData
      superData = {
        type: this.type,
        x: this.x,
        y: this.y,
        fieldName: this.fieldName,
        fontSize: this.fontSize,
        fontName: this.fontName,
        orientation: this.orientation,
        // tag: this.tag,
        visible: this.visible,
        magnet: this.magnet,
        placeholder: this.placeholder,
        value: this.value,
        name: this.name,
        inverse: this.inverse
      }
      return { 'ObjectID': this.id, 'ObjectClass': this.type, 'Content': JSON.stringify(superData) }
    },
    Importar: function (instancia) {
      if (instancia.type === 'text') {
        this.x = instancia.x
        this.y = instancia.y
        this.fieldName = instancia.fieldName
        this.fontSize = instancia.fontSize
        this.fontName = instancia.fontName
        this.orientation = instancia.orientation
        // this.tag = instancia.tag,
        this.visible = instancia.visible
        this.magnet = instancia.magnet
        this.placeholder = instancia.placeholder
        this.value = instancia.value
        this.name = instancia.name
        this.inverse = instancia.inverse

        var contx = canvas1.getContext('2d')
        contx.font = instancia.fontSize + 'px ' + instancia.fontName
        if (instancia.orientation === 0) {
          this.S = instancia.y - (instancia.fontSize * 2 / 3)
          this.I = instancia.y
          this.L = instancia.x
          this.R = instancia.x + Math.round(contx.measureText(instancia.fieldName).width)
        } else if (instancia.orientation === 90) {
          this.S = instancia.y - contx.measureText(instancia.fieldName).width
          this.I = instancia.y
          this.L = instancia.x - (instancia.fontSize * 2 / 3)
          this.R = instancia.x
        } else if (instancia.orientation === 180) {
          this.S = instancia.y
          this.I = instancia.y + (instancia.fontSize * 2 / 3)
          this.L = instancia.x - contx.measureText(instancia.fieldName).width
          this.R = instancia.x
        } else {
          this.S = instancia.y
          this.I = instancia.y + contx.measureText(instancia.fieldName).width
          this.L = instancia.x
          this.R = instancia.x + (instancia.fontSize * 2 / 3)
        }
      }
    },
    S: 0,
    I: 0,
    L: 0,
    R: 0,
    multiChoice: false
  }
  Texto.S = Y - (FontSize * 2 / 3)
  Texto.L = X
  if (Orientation === 0) {
    Texto.I = Y + (FontSize)
    Texto.R = X + Math.round(contx.measureText(FieldName).width)
  } else if (Orientation === 90) {
    Texto.I = Y + Math.round(contx.measureText(FieldName).width)
    Texto.R = X + (FontSize)
  } else if (Orientation === 180) {
    Texto.I = Y + (FontSize)
    Texto.R = X + Math.round(contx.measureText(FieldName).width)
  } else {
    Texto.I = Y + Math.round(contx.measureText(FieldName).width)
    Texto.R = X + (FontSize)
  }
  Texto.name = 'Texto ' + Texto.id
  lista.push(Texto)

  select(identificador)
  identificador++
  vueInstance.data2.lista = lista
}
function drawCode (X, Y, Orientation, Width, Height, type, Code) { // *<CH>*
  var CodeVar = {
    id: identificador,
    type: 'code',
    x: X + canvasX,
    y: Y + canvasY,
    w: Width,
    h: Height,
    s: 5,
    barcodeType: type,
    code: Code,
    orientation: Orientation,
    visible: true,
    DiffX: 0,
    DiffY: 0,
    ejemplo: 'Example',
    name: 'Code',
    barcodeText: true,
    mousemove: function () {
      var canvas = document.getElementById('CANVAS')
      var rect = canvas.getBoundingClientRect()
      canvasX = rect.left - document.getElementById('navigator').offsetWidth
      canvasY = rect.top - document.getElementById('header').offsetHeight + window.pageYOffset
      var H = document.getElementById('barcode' + this.id).clientHeight
      var W = document.getElementById('barcode' + this.id).clientWidth
      var XX = Math.round(PosX - this.DiffX - canvasX)
      var YY = Math.round(PosY - this.DiffY - canvasY)
      if (this.orientation === 0) {
        if (XX + W >= canvasWidth) { XX = canvasWidth - W } //  El orden al analizar los bordes es importante cuando el objeto es más grande que el lienzo
        if (YY + H > canvasHeight) { YY = canvasHeight - H }
        if (XX <= 0) { XX = 0 }
        if (YY <= 0) { YY = 0 }
        this.x = Math.round(XX + canvasX)
        this.y = Math.round(YY + canvasY)
        this.S = YY
        this.I = YY + H
        this.L = XX
        this.R = XX + W
      } else {
        if (XX + H >= canvasWidth) { XX = canvasWidth - H } //  El orden al analizar los bordes es importante cuando el objeto es más grande que el lienzo
        if (YY + W > canvasHeight) { YY = canvasHeight - W }
        if (XX <= 0) { XX = 0 }
        if (YY <= 0) { YY = 0 }
        this.x = Math.round(XX + canvasX)
        this.y = Math.round(YY + canvasY)
        this.S = YY
        this.I = YY + W
        this.L = XX
        this.R = XX + H
      }
    },
    mousedown: function () {
      mousedownID = setInterval(whilemousedown, 25)
    },
    actualitzar: function () {
      this.orientation = parseInt(vueInstance.data2.selectedItem.orientation)
      this.barcodeType = vueInstance.data2.typeOfCode
      this.x = parseInt(vueInstance.data2.selectedItem.x)
      this.y = parseInt(vueInstance.data2.selectedItem.y)
      this.code = vueInstance.data2.selectedItem.code
      this.ejemplo = vueInstance.data2.selectedItem.ejemplo
      if (this.barcodeType === 'datamatrix') {
        this.s = vueInstance.data2.selectedItem.s
      } else {
        var W
        var H
        try {
          W = parseInt(vueInstance.data2.selectedItem.w)
        } catch (err) {
          W = 100
        }
        try {
          H = parseInt(vueInstance.data2.selectedItem.h)
        } catch (err) {
          H = 100
        }
        this.w = W
        this.h = H
      }
    },
    draw: function (ID, i) {
      var color1 = 'black'
      var color2 = '#000000'
      var color3 = '000000'
      if (this.id === ID) {
        color1 = 'red'
        color2 = '#FF0000'
        color3 = 'FF0000'
      } else if (this.multiChoice) {
        color1 = 'green'
        color2 = '#008000'
        color3 = '008000'
      }
      try {
        var CODE = ''
        if (isEdition) {
          CODE = this.code
        } else {
          CODE = this.ejemplo
        }
        if (this.barcodeType === 'maxicode') {
          let canvas = bwipjs.toCanvas('barcodeCanvas', {
            bcid: 'maxicode',
            text: CODE,
            includetext: true,
            scale: 3,
            barcolor: color3,
            mode: 4
          })
          var codigo = document.getElementById('barcode' + this.id)
          codigo.src = canvas.toDataURL("image/png")
          codigo.height = 195
        }
        else if (this.barcodeType === 'hibcpdf417') {
          if(this.h > 10) {
            this.h = 1
          }
          let canvas = bwipjs.toCanvas('barcodeCanvas', {
            bcid: 'hibcpdf417',
            text: CODE,
            includetext: true,
            barcolor: color3,
            scale: this.h
          })
          var codigo = document.getElementById('barcode' + this.id)
          codigo.src = canvas.toDataURL("image/png")
          this.w = 1
        }
        else if (this.barcodeType !== 'datamatrix') {
          $('#barcode' + this.id).JsBarcode(CODE, {
            displayValue: this.barcodeText,
            width: this.w,
            height: this.h,
            quite: 10,
            format: this.barcodeType,
            background: 'transparent',
            lineColor: color1
          })
        } else {
          $('#barcode' + this.id).barcode(CODE, 'datamatrix', {
            barWidth: 1,
            barHeight: 50,
            moduleSize: this.s,
            showHRI: true,
            addQuietZone: true,
            marginHRI: 5,
            bgColor: '#FFFFFF',
            color: color2,
            fontSize: 10, // En datamatrix se puede quitar el texto de abajo poniendo este campo a 0
            output: 'css',
            posX: 0,
            posY: 0
          })
        }
        vueInstance.data2.showSnackbar = false
      } catch (err) {
        var stError = String(err)
        if(!stError.includes("PDF417")){
          var text = stError.split("\"")
          var value = text[1]
          var code = text[2].split("for")[1]
          vueInstance.data2.snackbar.color = 'warning'
          vueInstance.data2.snackbar.message = "\"" + value + "\" " + vueInstance.methods.getTranslated('_notValidInput') + " " + code
          vueInstance.data2.showSnackbar = true
        } else {
          vueInstance.data2.snackbar.color = 'warning'
          vueInstance.data2.snackbar.message = "\"" + vueInstance.methods.getTranslated('_pdf417Error') + "\""
          vueInstance.data2.showSnackbar = true
        }
      }
      var rot = 'rotate(' + this.orientation + 'deg)'
      var W = document.getElementById('barcode' + this.id).clientWidth
      var H = document.getElementById('barcode' + this.id).clientHeight
      var X1
      var Y1
      if (this.orientation === 0) {
        X1 = this.x
        Y1 = this.y
      } else {
        X1 = this.x - (W - H) / 2
        Y1 = this.y + (W - H) / 2
      }
      var rule = 'left: ' + X1 + 'px; '
      rule += 'top: ' + Y1 + 'px; '
      rule += 'width: inherit; '
      rule += 'transform: ' + rot + '; '
      rule += '-ms-transform: ' + rot + '; '
      rule += '-moz-transform: ' + rot + '; '
      rule += '-webkit-transform: ' + rot + '; '
      rule += '-o-transform: ' + rot + ';'
      try {
        sheet.deleteRule(this.id) // TODO Carlos Cambiando i por this.id parece funcionar // Cuando se elimina el primer código de barras deja de funcionar bien
      } catch (err) {
        // console.error(err)
      }
      sheet.insertRule('#barcode' + this.id + '{' + rule + '}', i) 
      
      var y = 0
      var found = false
      do {
        if (lista[y].id === this.id) {
          W = document.getElementById('barcode' + this.id).clientWidth
          H = document.getElementById('barcode' + this.id).clientHeight
          var Y = this.y
          var X = this.x
          if (this.orientation === 0) {
            this.S = Y - canvasY
            this.I = Y - canvasY + H
            this.L = X - canvasX
            this.R = X - canvasX + W
          } else {
            this.S = Y - canvasY
            this.I = Y - canvasY + W
            this.L = X - canvasX
            this.R = X - canvasX + H
          }
          found = true
        } else {
          y++
        }
      } while (!found && y < lista.length)

    },
    Exportar: function () {
      var superData
      superData = {
        type: this.type,
        x: this.x,
        y: this.y,
        canvasX: Math.round(canvasX),
        canvasY: Math.round(canvasY),
        width: this.w,
        height: this.h,
        size: this.s,
        barcodeType: this.barcodeType,
        fieldName: this.code,
        value: this.ejemplo,
        orientation: this.orientation,
        visible: this.visible,
        name: this.name,
        barcodeText: this.barcodeText
      }
      return { 'ObjectID': this.id, 'ObjectClass': this.type, 'Content': JSON.stringify(superData) }
    },
    Importar: function (instancia) {
      var canvas = document.getElementById('CANVAS')
      var rect = canvas.getBoundingClientRect()
      canvasX = rect.left - document.getElementById('navigator').offsetWidth
      canvasY = rect.top - document.getElementById('header').offsetHeight + window.pageYOffset

      if (canvasY != instancia.canvasY) {
        instancia.y += canvasY - instancia.canvasY
      }

      if (canvasX != instancia.canvasX) {
        instancia.x += canvasX - instancia.canvasX
      }

      if (instancia.type === 'code') {
        this.x = instancia.x
        this.y = instancia.y
        this.w = instancia.width
        this.h = instancia.height
        this.s = instancia.size
        this.barcodeType = instancia.barcodeType
        this.code = instancia.fieldName
        this.ejemplo = instancia.value
        this.orientation = instancia.orientation
        this.visible = instancia.visible
        this.name = instancia.name
        this.barcodeText = instancia.barcodeText
      }
    },
    S: 0,
    I: 0,
    L: 0,
    R: 0,
    multiChoice: false
  }
  CodeVar.name = 'Code ' + CodeVar.id
  lista.push(CodeVar)

  select(identificador)
  identificador++
  vueInstance.data2.lista = lista
}
function drawImage (X, Y, Width, Hight) { // *<CH>*
  var ImageVar = {
    id: identificador,
    type: 'image',
    x: X,
    y: Y,
    w: Width,
    h: Hight,
    predefined: true,
    src: 'undefined',
    designerSelectedImage: 'undefinedName',
    isVariable: false,
    visible: true,
    DiffX: 0,
    DiffY: 0,
    name: 'Image',
    mousemove: function () {
      var H = this.h
      var W = this.w
      var XX = Math.round(PosX - this.DiffX)
      var YY = Math.round(PosY - this.DiffY)
      if (XX + W >= canvasWidth) { XX = canvasWidth - W } //  El orden al analizar los bordes es importante cuando el objeto es más grande que el lienzo
      if (YY + H > canvasHeight) { YY = canvasHeight - H }
      if (XX <= 0) { XX = 0 }
      if (YY <= 0) { YY = 0 }
      this.x = XX
      this.y = YY
      this.S = YY
      this.I = YY + H
      this.L = XX
      this.R = XX + W
    },
    mousedown: function () {
      mousedownID = setInterval(whilemousedown, 25)
    },
    actualitzar: function (Launched) {
      this.x = parseInt(vueInstance.data2.selectedItem.x)
      this.y = parseInt(vueInstance.data2.selectedItem.y)
      this.w = parseInt(vueInstance.data2.selectedItem.w)
      this.h = parseInt(vueInstance.data2.selectedItem.h)
      this.predefined = vueInstance.data2.selectedItem.predefined
      if (this.isVariable) {
        this.designerSelectedImage = vueInstance.data2.isVariableName
        this.src = 'undefined'
      } else {
        this.designerSelectedImage = vueInstance.data2.selectedImage !== undefined ? vueInstance.data2.selectedImage.labelImageName : 'undefinedName'
        this.src = vueInstance.data2.selectedImage !== undefined ? 'data:image/' + vueInstance.data2.selectedImage.labelImageExtension + ';base64,' + vueInstance.data2.selectedImage.image : 'undefined'
        if (Launched) {
          if (this.predefined) {
            var IMG = vueInstance.data2.preselectedImages[0]
            this.designerSelectedImage = IMG
          } else {
            this.designerSelectedImage = vueInstance.data2.importedImages[0]
          }
        }
      }
    },
    draw: function (ID) {
      var canvas = document.getElementById('CANVAS')
      var ctx = canvas.getContext('2d')
      ctx.beginPath()

      //  var Name = this.designerSelectedImage.slice(0, -4); //  Le quito la terminación '.bmp'
      var name = this.designerSelectedImage
      if (!this.isVariable) {
        if (!$('#' + name).length) {
          var text = '<img id=\'' + name + '\' src=\'' + this.src + '\' style=\'display:none\' />'
        }
      } else {
        name = 'variable'
        var text = '<img id=\'' + name + '\' src=\' data:image/png;base64,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\' style=\'display:none\' />'
      }
      document.getElementById('ImageAmmo').insertAdjacentHTML('beforeend', text)

      var img = document.getElementById(name)
      try {
        if (!img.src.includes('undefined')) {
          ctx.drawImage(img, this.x, this.y, this.w, this.h)
        }
      } catch (err) {
        console.error(err)
      }
      if (ID === this.id || this.multiChoice) {
        var color = ''
        if (this.multiChoice) {
          color = 'green'
        } else {
          color = 'red'
        }
        ctx.beginPath()
        ctx.strokeStyle = color
        ctx.rect(this.x, this.y, this.w, this.h)
        this.I = this.y + this.h
        this.R = this.x + this.w
        ctx.lineWidth = 2
        ctx.stroke()
      }
    },
    Exportar: function () {
      var superData
      superData = {
        type: this.type,
        x: this.x,
        y: this.y,
        width: this.w,
        height: this.h,
        predefined: this.predefined,
        src: this.src,
        designerSelectedImage: this.designerSelectedImage,
        isVariable: this.isVariable,
        visible: this.visible,
        name: this.name
      }
      return { 'ObjectID': this.id, 'ObjectClass': this.type, 'Content': JSON.stringify(superData) }
    },
    Importar: function (instancia) {
      if (instancia.type === 'image') {
        this.x = instancia.x
        this.y = instancia.y
        this.w = instancia.width
        this.h = instancia.height
        this.predefined = instancia.predefined
        this.src = instancia.src
        this.designerSelectedImage = instancia.designerSelectedImage
        this.isVariable = instancia.isVariable
        if (this.isVariable) {
          vueInstance.data2.isVariableName = this.designerSelectedImage
        }
        this.visible = instancia.visible
        this.name = instancia.name
        this.S = instancia.y
        this.L = instancia.x
      }
    },
    S: Y,
    I: Y + Hight,
    L: X,
    R: X + Width,
    multiChoice: false
  }
  ImageVar.name = 'Image ' + ImageVar.id
  lista.push(ImageVar)
  select(identificador)
  identificador++
  vueInstance.data2.lista = lista
  LookingImage()
}

function _base64ToArrayBuffer(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
}

/*
Función IMPORT  *<CH>*
  Función para recibir una etiqueta de la base de datos
  Carga una lista y la recorre para crear los Objetos de la lista (En caso de añadir nuevos objetos se deberà modificar este metodo)
  Necesita un ID de etiqueta para pedirlo al servidor y al final carga una nueva lista 'lista[]' con la nueva etiqueta
*/
async function Import (ID, version) { // *<CH>*
  clearCanvas()

  await LabelDesignerService.getEtiquetaVersion(ID, version).then(res => {
    if (res.request.status === 200 || res.request.status === 201) {
      var obj = JSON.parse(res.data.labelJsonCode)
      BigName = res.data.labelName
      vueInstance.data2.saveNameDialog = res.data.labelName
      vueInstance.data2.labelDescription = res.data.labelDescription
      vueInstance.data2.canvasHeightDialog = obj.CanvasHeight
      vueInstance.data2.canvasWidthDialog = obj.CanvasWidth
      
      var purposesList = res.data.purposes

      purposesList.forEach(element => {
        
        var newTypeValue = {
          Type: element.type.id,
          Value: element.purposeValue
        }

        vueInstance.data2.purposes.push(newTypeValue)

      })
      
      ChangeCanvasSize()
      BigId = obj.LabelID

      for (var cont = 0; cont < obj.Objects.length; cont++) {
        var variable = (JSON.parse(obj.Objects[cont].Content))

        switch (variable.type) {
          case 'line':
            drawLine(0, 0, 0, true, 0)
            break;
          case 'square':
            drawSquare(0, 0, 0, 0, 0)
            break;
          case 'text':
            drawText(0, 0, 'Sample', 0, 'Arial', 0)
            break;
          case 'code':
            drawCode(0, 0, 0, 0, 0, 'CODE128', 'Sample')
            break;
          case 'image':
            drawImage(0, 0, 0, 0)
            break;
          default:
            break;
        }

        lista[identificador - 1].Importar(variable)
      }
      diselect()
      redraw(-1)
      vueInstance.data2.snackbar.color = 'green'
      vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_labelImported')
      vueInstance.data2.showSnackbar = true
    } else {
      vueInstance.data2.snackbar.color = 'red'
      vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_labelImportedError')
      vueInstance.data2.showSnackbar = true
    }
  })
}

/*
Función EXPORT
  Función para enviar la etiqueta a la base de datos
  Pide a cada objeto en la lista 'lista[]' que se devuelva a si mismo usando su propio metodo,
    los pone en un nuevo objeto que convierte a JSON y lo envia al servidor.
  Devuelve un true o false y da un mensaje informativo usando la div de Alertas.
*/
async function Export () {
  var nombre = vueInstance.data2.saveNameDialog
  var description = vueInstance.data2.labelDescription
  var version = vueInstance.data2.etiquetaVersion !== '' ? vueInstance.data2.etiquetaVersion : 0

  if (lista.length !== 0) {
    var ObjectList = []
    ObjectList.length = 0
    for (var i = 0; i < lista.length; i++) {
      var Info = lista[i].Exportar()
      ObjectList.push(Info)
    }

    if (vueInstance.data2.newName && vueInstance.data2.newValue) {

      var newNameValue = {
        Type: vueInstance.data2.newName,
        Value: vueInstance.data2.newValue
      }
      vueInstance.data2.newName = ''
      vueInstance.data2.newValue = ''
      vueInstance.data2.purposes.push(newNameValue)

    }

    vueInstance.data2.saveLoading = true

    var EntregaData = {'Label': { 'LabelID': BigId, 'Name': nombre, 'Version': version, 'Objects': ObjectList, 'Description': description, 'CanvasWidth': vueInstance.data2.canvasWidthDialog, 'CanvasHeight': vueInstance.data2.canvasHeightDialog }, 'Purposes': vueInstance.data2.purposes }
    await LabelDesignerService.saveEtiqueta(EntregaData).then(res => {
      if (res.request.status === 200 || res.request.status === 201) {
        vueInstance.data2.snackbar.color = 'green'
        vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_labelSaved')
        vueInstance.data2.showSnackbar = true
        vueInstance.data2.etiquetaID = res.data.id
      } else {
        vueInstance.data2.snackbar.color = 'red'
        vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_labelSavedError')
        vueInstance.data2.showSnackbar = true
      }
      vueInstance.data2.saveLoading = false
    })
  }
}

async function ExportZpl () {
  if (lista.length !== 0) {
    var ObjectList = []
    ObjectList.length = 0
    for (var i = 0; i < lista.length; i++) {
      var Info = lista[i].Exportar()
      ObjectList.push(Info)
    }
    var EntregaData = { 'Name': 'Label', 'Objects': ObjectList }
    await LabelDesignerService.getZpl(EntregaData).then(res => {
      if (res.request.status === 200 || res.request.status === 201) {
        vueInstance.data2.snackbar.color = 'green'
        vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_exportSuccessfully')
        vueInstance.data2.showSnackbar = true

        vueInstance.data2.zplLabelCode = res.data
        vueInstance.data2.showZplLabelDialog = true
      } else {
        vueInstance.data2.snackbar.color = 'red'
        vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_errorExporting')
        vueInstance.data2.showSnackbar = true
      }
    })
  }
}

async function ExportPDF () {
  if (lista.length !== 0) {
    var ObjectList = []
    ObjectList.length = 0
    for (var i = 0; i < lista.length; i++) {
      var Info = lista[i].Exportar()
      ObjectList.push(Info)
    }
    var EntregaData = { 'Name': 'Label', 'Objects': ObjectList, 'CanvasWidth': vueInstance.data2.canvasWidthDialog, 'CanvasHeight': vueInstance.data2.canvasHeightDialog }
    await LabelDesignerService.getPdf(EntregaData).then(res => {
      if (res.request.status === 200 || res.request.status === 201) {
        vueInstance.data2.snackbar.color = 'green'
        vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_exportSuccessfully')
        vueInstance.data2.showSnackbar = true

        vueInstance.data2.exportedPdf = res.data
      } else {
        vueInstance.data2.snackbar.color = 'red'
        vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_errorExporting')
        vueInstance.data2.showSnackbar = true
      }
    })
  }
}

/*
Función LOOKINGIMAGE
  Función para buscar los nombres de las imagenes
    Utiliza las 2 funciones siguientes para importar los nombres tanto de las importadas como de las predefinidas
*/
async function LookingImage (ID) {
  await LabelDesignerService.getImportedImages().then(res => {
    vueInstance.data2.importedImages = res.data
  })

  await LabelDesignerService.getPredefinedImages().then(res => {
    vueInstance.data2.preselectedImages = res.data
  })
}

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => resolve(reader.result)
  reader.onerror = error => reject(error)
})

function isValidName(imageName) {
  const re = new RegExp('[^A-Za-z0-9_]')
  return !re.test(imageName)
}

/*
Función ImportImage
  Función que se encargará de pasar la imagen al servidor para poder operar con esta
*/
async function ImportImage () {
  var nombre = vueInstance.data2.imageName
  var archivo = vueInstance.data2.importedImageDialog

  if (!archivo.type.includes('image/')) {
    vueInstance.data2.snackbar.color = 'red'
    vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_imageLoadFormatError')
    vueInstance.data2.showSnackbar = true

    return
  }
  
  if (archivo.size > (20 * 1024)) {
    vueInstance.data2.snackbar.color = 'red'
    vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_imageLimitSizeError')
    vueInstance.data2.showSnackbar = true
    
    return
  }

  if (!isValidName(nombre)) {
    vueInstance.data2.snackbar.color = 'red'
    vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_imageNameNotValidError')
    vueInstance.data2.showSnackbar = true
    
    return
  }

  var image64 = await toBase64(archivo)

  await LabelDesignerService.saveImage(nombre, image64).then(res => {
    if (res.request.status === 200 || res.request.status === 201) {
      vueInstance.data2.snackbar.color = 'green'
      vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_imageSaved')
      vueInstance.data2.showSnackbar = true
    } else {
      vueInstance.data2.snackbar.color = 'red'
      vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_imageSavedError')
      vueInstance.data2.showSnackbar = true
    }
    LookingImage()
  }).catch(err => {
    if (err.response.data.imageAlreadyExists) {
      vueInstance.data2.snackbar.color = 'red'
      vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_imageNameAlreadyExistsError')
      vueInstance.data2.showSnackbar = true
    } else {
      vueInstance.data2.snackbar.color = 'red'
      vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_imageSavedError')
      vueInstance.data2.showSnackbar = true
    }
  })
}

/*
Función CLEARCANVAS
  Función que limpia todo el contenido de la lista 'lista[]' eliminando su contenido,
    reinicia el identificador para empezar con una nueva etiqueta,
    borra el canvas y elimina el contenido de la dev de códigos.
*/
function clearCanvas () {
  var canvas = document.getElementById('CANVAS')
  var ctx = canvas.getContext('2d')
  var códigos = ''

  lista.length = 0
  identificador = 0
  ctx.clearRect(0, 0, canvasWidth, canvasHeight)
  document.getElementById('Code_Charger').innerHTML = códigos
  PosSel = -1
  vueInstance.data2.lista = []
  vueInstance.data2.selectedItem = {}
  vueInstance.data2.canvasWidthDialog = 75
  vueInstance.data2.canvasHeightDialog = 87.5
  ChangeCanvasSize()
}

/*
Función CHANGEMODE
  Función para cambiar el modo de edición de las etiquetas,
    los textos etiqueta mostraran su ejemplo en lugar de el nombre de la etqueta,
    despues vuelve a dibujar el contenido del canvas
*/
function ChangeMode () {
  if (isEdition) {
    isEdition = !isEdition
    vueInstance.data2.buttonModeText = vueInstance.methods.getTranslated('_example')
  } else {
    isEdition = !isEdition
    vueInstance.data2.buttonModeText = vueInstance.methods.getTranslated('_edition')
  }
  redraw(PosSel)
}

/*
Función HIDE
  Función para cambiar la propiedad de cada objeto que permite que este se dibuje a false.
    Siempre debe deselecionar el objeto actual para evitar mover el objeto sin verlo,
    recarga la lista de objetos en el menú de usuario para actualizar su situación.
*/
function hide (ID) {
  var x = 0
  var found = false
  do {
    if (lista[x].id === ID) {
      lista[x].visible = false
      found = true
    } else {
      x++
    }
  } while (!found && x < lista.length)

  // diselect()
  redraw(ID)
}

/*
Función SHOW
  Función para cambiar la propiedad de cada objeto que permite que este se dibuje a true.
    Siempre debe deseleciónar el objeto actual para evitar problemas de selección,
    recarga la lista de objetos en el menú de usuario para actualizar su situación.
*/
function show (ID) {
  var x = 0
  var found = false
  do {
    if (lista[x].id === ID) {
      lista[x].visible = true
      found = true
    } else {
      x++
    }
  } while (!found && x < lista.length)

  // diselect()
  redraw(ID)
}

/*
Función CHANGECANVASSIZE
  Función que actualiza los valores de tamaño del lienzo ya justa las divs de fondo para que no se solapen con el contenido
  (Se hace con los margenes en lugar de la parte posterior del canvas porque segun ciertas condiciones un objeto puede salir del canvas,
  y los códigos de barras se seguirian cargando fuera)
*/
function ChangeCanvasSize () {
  var W = parseInt(vueInstance.data2.canvasWidthDialog) * 8
  var H = parseInt(vueInstance.data2.canvasHeightDialog) * 8

  var card = document.getElementById('vcard')
  card.style.width = W + 'px'
  card.style.height = H + 'px'
  vueInstance.data2.canvasWidth = W + 'px'
  vueInstance.data2.canvasHeight = H + 'px'
  var text = '<canvas id=\'CANVAS\' width=\'' + W + '\' height=\'' + H + '\'></canvas>'
  var check = (document.getElementById('CANVAS_container').innerHTML = text)
  if (check) {
    canvasWidth = W
    canvasHeight = H
    redraw(-1)
  }
}

/*
Función DELETE
  Función para eliminar un objeto de la etiqueta,
    aun no tiene dialogo de confirmación por lo que se borrará para siempre.
*/
function Delete (ID) {
  var x = 0
  var found = false
  do {
    if (lista[x].id === ID) {
      lista.splice(x, 1)
      found = true
    } else {
      x++
    }
  } while (!found && x < lista.length)
  
  // for (var a = 0; a < lista.length; a++) {
  //   if (lista[a].id === ID) {
  //     lista.splice(a, 1)
  //   }
  // }

  diselect()
}

/*
Function DISELECT
  Función que elimina todo el contenido de las divs donde se muestra el objeto seleccionado,
  pone a -1 la variable de selección (Variable que simula la no selección ya que el 0 es el primer elemento de la lista[])
*/
function diselect () {
  PosSel = -1
  document.getElementById('CANVAS').style.cursor = 'default'
  vueInstance.methods.deselectItem()
  redraw(-1)
}

/*
Función SELECT
  Función que carga todos los datos del objeto seleccionado para su visualización y manipulación
*/
function select (ID) {
  var x = 0
  var found = false
  do {
    if (lista[x].id === ID) {
      PosSel = x
      found = true
    } else {
      x++
    }
  } while (!found && x < lista.length)
  
  // for (var x = 0; x < lista.length; x++) {
  //   if (lista[x].id === ID) {
  //     PosSel = x
  //   }
  // }
  
  redraw(ID)
  document.getElementById('CANVAS').style.cursor = 'all-scroll'
  vueInstance.methods.selectItemById(ID)
}

/*
Función ACTUALIZAR
  Función que llama al metodo actualizar del objeto a actualizar y actualiza sus valores
*/
function actualizar (ID) {
  var object
  var x = 0
  var found = false
  do {
    if (lista[x].id === ID) {
      object = lista[x]
      found = true
    } else {
      x++
    }
  } while (!found && x < lista.length)

  if (object.visible) {
    object.actualitzar()
    redraw(ID)
  }
  
}

/*
*
* <<< Function to draw all the items in the Canvas >>>
*
*/
function redraw (ID) {
  if (window.location.pathname.includes('/labelManagement/LabelDesigner')) {
    var canvas = document.getElementById('CANVAS')
    var ctx = canvas.getContext('2d')
    var listaCodigos = []
    var codigos = ''
    ctx.clearRect(0, 0, canvasWidth, canvasHeight)

    for (var cont = 0; cont < lista.length; cont++) {
      var element = lista[cont]
      if (element.visible) {
        if (element.type === 'code') {
          listaCodigos.push(element.id)
          if (element.barcodeType === 'datamatrix') {
              codigos += '<div id=\'barcode' + element.id + '\' class=\'barcode\'></div>'
            } else {
              codigos += '<img id=\'barcode' + element.id + '\' class=\'barcode\' />'
            }
        } else {
          element.draw(ID)
        }
      }
    }

    document.getElementById('Code_Charger').innerHTML = codigos

    if (listaCodigos.length !== 0) {
      for (var i = 0; i < listaCodigos.length; i++) {
        for (var x = 0; x < lista.length; x++) {
          if (lista[x].id === listaCodigos[i]) {
            lista[x].draw(ID, i)
          }
        }
      }
    }
  }
}

/*
Función CHANGENAME
  Función para cambiar el nombre del objeto seleccionado y guardarlo en sus propiedades
*/
function changeName (ID) {
  var objeto = vueInstance.data2.changeName

  var x = 0
  var found = false

  do {
    if (lista[x].id === ID) {
      lista[x].name = objeto
      found = true
    } else {
      x++
    }
  } while (!found && x < lista.length)
}

/*
*
* Functions to control the movement in the canvas
*
*/
var mousedownID = -1 // Global ID of mouse down interval

/*
Función MORETHANONEALERT
  Función que regula el comportamiento cuando se hace clik para seleccionar objetos solapados
  Contiene un caso para seleción multiple y otro para selección simple
*/
function MoreThanOneAlert (ID, CASE) {
  if (CASE === 'single') {
    select(ID)
  } else if (CASE === 'multy') {
    for (var i = 0; i < lista.length; i++) {
      if (lista[i].id === ID && !lista[i].multiChoice) {
        lista[i].multiChoice = true
        multiChoiceList.push(ID)
      }
    }
    redraw(-1)
  }
}

/*
Función MOUSEDOWN
  Función evento que controla el comportamiento del click del ratón
*/
function mousedown (event) {
  var CASE
  if (mousedownID === -1 && PosX <= canvasWidth && PosY <= canvasHeight && PosX >= 0 && PosY >= 0 && event.button === 0) { // Comprobación que el click a ocurrido dentro del canvas y Comprobación del click izquierdo
    if (PosSel !== -1) { // Caso en que no hay ningún objeto seleccionado
      if (lista[PosSel].visible && apply) {
        lista[PosSel].DiffX = PosX - lista[PosSel].x
        lista[PosSel].DiffY = PosY - lista[PosSel].y
        apply = false
        lista[PosSel].mousedown()
      }
    } else if (event.ctrlKey) { // Caso de multiselección (CTRL + CLICK)
      MultipleSelection = true
      CASE = 'multy'
      CaseMoreThanOne(CASE)
      if (Selecting.length === 1) {
        for (var i = 0; i < lista.length; i++) {
          if (lista[i].id === Selecting[0] && !lista[i].multiChoice) {
            lista[i].multiChoice = true
            multiChoiceList.push(Selecting[0])
          }
        }
      }
      redraw(-1)
    } else if (!event.ctrlKey && MultipleSelection) { // Caso en que ya hay muchos items seleccionados (movimiento)
      for (var i = 0; i < multiChoiceList.length; i++) {
        if (apply) {
          for (var ID = 0; ID < lista.length; ID++) {
            lista[ID].DiffX = PosX - lista[ID].x
            lista[ID].DiffY = PosY - lista[ID].y
          }
          apply = false
        }
      }
      multimove()
      redraw(-1)
    } else { //  Caso general, selección simple
      CASE = 'single'
      CaseMoreThanOne(CASE)
      if (Selecting.length === 1) {
        select(Selecting[0])
      }
    }
  }
}

/*
* Función para cuando se pulsa encima de más de un objeto
*
* Se usa tanto para la selección simple como para la multiple
*
*/
function CaseMoreThanOne (CASE) {
  Selecting.length = 0
  var objectList = []
  for (var x = 0; x < lista.length; x++) {
    if (lista[x].visible) {
      if (lista[x].type === 'square') {
        if ((PosY >= lista[x].S && PosY <= lista[x].I && PosX >= lista[x].L && PosX <= lista[x].R) && (PosY <= lista[x].S2 || PosY >= lista[x].I2 || PosX <= lista[x].L2 || PosX >= lista[x].R2)) {
          Selecting.push(lista[x].id)
          objectList.push({ id: lista[x].id, name: lista[x].name })
        }
      } else if (PosY >= lista[x].S && PosY <= lista[x].I && PosX >= lista[x].L && PosX <= lista[x].R) {
        Selecting.push(lista[x].id)
        objectList.push({ id: lista[x].id, name: lista[x].name })
      }
    }
  }

  if (objectList.length > 1) {
    vueInstance.data2.multiSelected = {}
    vueInstance.data2.multiSelectList = objectList
    vueInstance.data2.showMultiSelectDialog = true
  }
}

/*
Función MULTIMOVE
  Función para mover los multiples objetos seleccionados
*/
function multimove () {
  mousedownID = setInterval(movemulty, 25)
}

/*
Función MOUSEUP
  Función para cesar los movimientos en caso de que se deje de pulsar o se salga del canvas con el raton
*/
function mouseup (event) {
  if (mousedownID !== -1) { // Only stop if exists
    clearInterval(mousedownID)
    mousedownID = -1
    apply = true
  }
}

/*
** Move the objects when selected and change the object box detection
**
**Each object box is reposicioned agree to his new object position
**
*/
function whilemousedown () {
  vueInstance.data2.lastActionSave = false
  lista[PosSel].mousemove()
  redraw(lista[PosSel].id)
}

/*
Función MOVEMULTY
  Función para el movimiento multiple de objetos
    Forma parte de las funciones encadenadas que permite actualizar las variables de cada objeto
      multiseleccionado para moverlos todos a la vez
*/
function movemulty () {
  for (var b = 0; b < multiChoiceList.length; b++) {
    for (var a = 0; a < lista.length; a++) {
      if (lista[a].id === multiChoiceList[b]) {
        lista[a].mousemove()
      }
    }
  }
  redraw(-1)
}

/*
Función que actualiza las variables locales de posición del ratón,
  se actualiza solo para el interior del canvas, pero siempre esta calculandose
*/
function Coords (event) {
  if (window.location.pathname.includes('/labelManagement/LabelDesigner')) {
    var canvas = document.getElementById('CANVAS')
    var rect = canvas.getBoundingClientRect()
    PosX = event.pageX - rect.left
    PosY = event.pageY - rect.top - window.pageYOffset

    // if (PosX < canvasWidth && PosX > 0 && PosY < canvasHeight && PosY > 0) { // Show the cordenates only when in the canvas
    //   var coords = '&nbsp X = ' + parseInt(PosX) + '<br> &nbsp Y = ' + parseInt(PosY)
    //   document.getElementById('Coordenates').innerHTML = coords
    // }
  }
}

/*
Función MOUSERIGHT
  Función para procesar el click derecho del raton, eliminando su comportamiento habitual
    ahora el click derecho desselecciona automáticamente cualquier objeto o objetos seleccionados.
*/
function mouseright (event) {
  if (window.location.pathname.includes('/labelManagement/LabelDesigner')) {
    event.preventDefault()

    if (MultipleSelection) {
      MultipleSelection = false
      for (var ID = 0; ID < lista.length; ID++) {
        lista[ID].multiChoice = false
      }
      multiChoiceList.length = 0
    }

    diselect()
    return false
  }
}

/*
Función KEYPRESS
  Función evento para controlar el comportamiento de la pulsación de teclas específicas (CTRL, etc)
    Contiene las funcionalidades de suprimir, copiar y pegar (manejados por combinaciones de teclas pertinentes).
    Elimina la funcionalidad por defecto del Ctrl + Z, ya que interfiere con el correcto funcionamiento del programa
*/
function keyPress (event) {
  if (window.location.pathname.includes('/labelManagement/LabelDesigner')) {

    // if (event.keyCode === 90 && event.ctrlKey) {
    //   event.preventDefault()
    //   vueInstance.data2.snackbar.color = 'warning'
    //   vueInstance.data2.snackbar.message = vueInstance.methods.getTranslated('_notPossibleTurnBackEvents')
    //   vueInstance.data2.showSnackbar = true
    // }

    if (event.keyCode === 46) {
      event.preventDefault()
      if (Object.keys(vueInstance.data2.selectedItem).length !== 0) {
        vueInstance.data2.showConfirmationDialog = true
      }
    }

    if (event.ctrlKey && event.keyCode === 67 && PosSel !== -1) { // Copy event
      Copy = Clonar(lista[PosSel])
    }

    if (event.ctrlKey && event.keyCode === 86 && Copy !== null) { // Paste event
      Copy.id = identificador
      Copy.name = 'Copy' + identificador
      lista.push(Copy)
      select(identificador)
      identificador++
      Copy = null
    }

    if (PosSel !== -1 && !event.shiftKey) {
      if (event.keyCode === 38 && lista[PosSel].y > 0) { // Up
        event.preventDefault()
        lista[PosSel].y = lista[PosSel].y - 1
        redraw(lista[PosSel].id)
      } else if (event.keyCode === 37 && lista[PosSel].x > 0) { // Left
        event.preventDefault()
        lista[PosSel].x = lista[PosSel].x - 1
        redraw(lista[PosSel].id)
      } else if (event.keyCode === 40) { // Down
        event.preventDefault()
        lista[PosSel].y = lista[PosSel].y + 1
        redraw(lista[PosSel].id)
      } else if (event.keyCode === 39) { // Right
        event.preventDefault()
        lista[PosSel].x = lista[PosSel].x + 1
        redraw(lista[PosSel].id)
      }
    }
  }
}

/*
Function CLONAR
  Función para sacar una copia identica de un objeto como un objeto nuevo, no altera su predecesor
*/
function Clonar (obj) {
  var prop, clone
  if (obj === null || typeof obj !== 'object') return obj

  if (obj.constructor === Date || obj.constructor === RegExp || obj.constructor === Function ||
    obj.constructor === String || obj.constructor === Number || obj.constructor === Boolean) {
    return new obj.constructor(obj)
  }

  if (obj.constructor !== Object && obj.constructor !== Array) return obj
  clone = new obj.constructor()

  for (prop in obj) {
    clone[prop] = Clonar(obj[prop])
  }

  return clone
}

/*
Eventos de entrada
  códigos para capturar los eventos de clicks o pulsados de teclas especificos
*/
document.addEventListener('mousedown', mousedown)
document.addEventListener('mouseup', mouseup)
document.addEventListener('mousemove', Coords)
// Capo comportamientos no deseados en la web para evitar problemas, (salir del canvas, botón derecho del ratón, Ctrl+Z, Ctrl, ...)
document.addEventListener('mouseout', mouseup)
document.addEventListener('contextmenu', mouseright)
document.addEventListener('keydown', keyPress)

</script>

<style>
  html {
    font-family: Roboto;
  }

  #ImageAmmo {
    display: none;
  }

  .barcode {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    z-index: auto; /* z-index puesto en auto para poder arrastrar la imagen, está en auto porque si no se pone detrás del v-app y no se ve */
    position: absolute;
    top: 200px;
    left: 100px;
    width: 200px;
  }
</style>
